
<template>
    <div class="container feedback template-bg-gray comm-req-page">
        <!-- 404 UI -->
        <NotFound
        v-if="showNotFound"
        :community_id="community_id"
        />
        <!-- regular page UI -->
        <div class="row" v-else>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec ">
                <div class="loop_container bg-transparent update-request-form-common">
                    <div class="card form-wrapper">
                        <div class="feedback_container feedback_newupdate">
                            <div class="row">
                                <div class="col-md-12 text-center" v-if="isShow">
                                    <img :src="logoURL" class="top-logo custom-logo" :alt="'Community Logo of '+ (community && community.content && community.content.parameter4 ? community.content.parameter4 : (community && community.name) || 'Community')">
                                </div>
                                <CustomSkeleton :is-visible="!isShow" />
                            </div>
                            <template v-if='isBeforeRequest && showFormFlag && isShow'>
                                <div class="">
                                    <!-- <ul class="nav nav-tabs template-tab-ul" id="myTab" >
                                        <li class="nav-item" role="presentation">
                                          <a href="javascript:void(0)" role="tab"  :aria-selected="isFirstPage ? 'true' : 'false'">
                                            <p class="nav-link" v-bind:class="{'active': isFirstPage}">1</p>
                                            <span>About you</span>
                                          </a>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                          <a href="javascript:void(0)" role="tab"  :aria-selected="isSecondPage ? 'true' : 'false'">
                                            <p class="nav-link" v-bind:class="{'active': isSecondPage}">2</p>
                                            <span>Let's Review</span>
                                          </a>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                          <a href="javascript:void(0)" role="tab"  :aria-selected="isThirdPage ? 'true' : 'false'">
                                            <p class="nav-link" v-bind:class="{'active': isThirdPage}">3</p>
                                            <span>One More Thing!</span>
                                          </a>
                                        </li>
                                    </ul> -->
                                    <div class="tab-content" id="myTabContent">
                                        <div class="tab_inn" v-show="isFirstPage" aria-live="polite" aria-atomic="false">
                                            <h1 id="requestHelpHeader" class="template-title common-space-from-logo">
                                                What do you need help with?
                                                <Tooltip
                                                    content="This form will help us match you with the right experts in our community who can provide guidance on your specific question."
                                                    aria-label="Help with this form"
                                                    role="button"
                                                    :isInteractive="true"
                                                />
                                            </h1>
                                            <p class="box-sub-heading mb35 custom-content request-form-title-anchor-tab" v-if="community.content && community.content.requestIntroduction" v-html="sanitizeListHTML(community.content.requestIntroduction)"></p>
                                            <p class=" box-sub-heading mb35 custom-content request-form-title-anchor-tab" v-else >We need a little bit of information to match you to relevant experts in the community.</p>
                                            <form @submit.prevent="viewSecondPage('step-1'), handleFocusOnQuestionError()" data-vv-scope="step-1" class="template-form">
                                                <p class="required-note template-label" id="required-note">
                                                    Fields marked with an asterisk (<span class="required-symbol">*</span>) are required.
                                                    <Tooltip
                                                        content="All fields with a red asterisk (*) must be filled out before you can proceed to the next step."
                                                        aria-label="Required fields information"
                                                        role="button"
                                                        :isInteractive="true"
                                                    />
                                                </p>
                                                <div class="row responsive-v3-class">
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17 ">
                                                            <div class="input-group">
                                                                <label class="template-label" for="firstName">{{configureFields.firstName.labelName}} <span class="required-symbol"> *</span></label>
                                                                <input
                                                                    type="text"
                                                                    class="form-control input-value pt-input input-focus"
                                                                    ref="firstName"
                                                                    id="firstName"
                                                                    v-model="dynamicFields.first"
                                                                    name="first"
                                                                    autocomplete="given-name"
                                                                    placeholder=""
                                                                    required
                                                                    aria-required ="true"
                                                                    v-validate="'required'"
                                                                    v-focus
                                                                    v-bind:class="{'request-form-error-border': errors.has('step-1.first') }"
                                                                    @input="e => dynamicFields.first = sanitizeInput(e.target.value)"
                                                                    data-vv-validate-on="change"
                                                                >
                                                                <p
                                                                    class="error"
                                                                    v-show="errors.has('step-1.first')"
                                                                >{{errors.first('step-1.first')}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17">
                                                            <div class="input-group">
                                                                <label class="template-label" for="lastName">{{configureFields.lastName.labelName}}<span class="required-symbol"> *</span></label>
                                                                <input
                                                                    type="text"
                                                                    id="lastName"
                                                                    autocomplete="family-name"
                                                                    class="form-control input-value pt-input input-focus"
                                                                    v-model="dynamicFields.last"
                                                                    name="last"
                                                                    placeholder=""
                                                                    required
                                                                    aria-required="true"
                                                                    v-validate="'required'"
                                                                    v-bind:class="{'request-form-error-border': errors.has('step-1.last') }"
                                                                    data-vv-validate-on="change"
                                                                    @input="e => dynamicFields.last = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                class="error"
                                                                v-show="errors.has('step-1.last')"
                                                                >{{errors.first('step-1.last')}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17">
                                                            <div class="input-group">
                                                                <label class="template-label" for="email">{{configureFields.emailAddress.labelName}}<span class="required-symbol"> *</span></label>
                                                                <input
                                                                    type="email"
                                                                    autocomplete="email"
                                                                    class="form-control input-value pt-input input-focus"
                                                                    id="email"
                                                                    v-model="dynamicFields.email"
                                                                    @change="checkMemberStatus"
                                                                    name="email"
                                                                    placeholder=""
                                                                    required
                                                                    aria-required="true"
                                                                    v-validate.continues="'required|email'"
                                                                    v-bind:class="{'request-form-error-border': errors.has('step-1.email') }"
                                                                    data-vv-validate-on="change"
                                                                    @input="e => dynamicFields.email = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                v-show="errors.has('step-1.email')"
                                                                class="error"
                                                                >{{ errors.first('step-1.email') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.memberRole && configureFields.memberRole.include && configureFields.memberRole.include === true">
                                                            <div class="input-group">
                                                                <label class="template-label" for="memberRole">{{memberRole.labelName}} <span class="required-symbol" v-if="checkAndValidate1('memberRole')"> *</span></label>
                                                                <select
                                                                    v-validate="`${checkAndValidate1('memberRole')}`"
                                                                    class="form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown"
                                                                    v-model="dynamicFields.memberRole"
                                                                    name="memberRole"
                                                                    id="memberRole"
                                                                    data-vv-validate-on="change|blur"
                                                                    v-bind:class="{'request-form-error-border': errors.has('step-1.memberRole') }"
                                                                    :aria-required="checkAndValidate1('memberRole') ? 'true' : 'false'"

                                                                >
                                                                    <option value="" selected disabled style="display:none">Select role</option>
                                                                    <option v-for="role in memberRole.memberValue" :key="role" :value="role.trim()">{{role.trim()}}</option>
                                                                </select>
                                                                <p v-show="errors.has('step-1.memberRole')" class="error">{{ errors.first('step-1.memberRole') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.phoneNumber && configureFields.phoneNumber.include && configureFields.phoneNumber.include === true">
                                                            <div class="row">
                                                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                    <div class="input-group" >
                                                                    <label class="template-label" for="phoneNumber">{{configureFields.phoneNumber.labelName}} <span class="required-symbol" v-if="checkAndValidate1('phoneNumber')"> *</span></label>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control input-value pt-input input-focus"
                                                                        id="phoneNumber"
                                                                        v-model="dynamicFields.phoneNumber"
                                                                        name="phoneNumber"
                                                                        v-validate.continues="`${checkAndValidate1('phoneNumber')}`"
                                                                        v-bind:class="{'request-form-error-border': errors.has('step-1.phoneNumber') }"
                                                                        data-vv-validate-on="change"
                                                                        :aria-required="checkAndValidate1('phoneNumber') ? 'true' : 'false'"
                                                                        @input="e => dynamicFields.phoneNumber = sanitizeInput(e.target.value)"
                                                                    >
                                                                    <p
                                                                        v-show="errors.has('step-1.phoneNumber')"
                                                                        class="error"
                                                                        >{{ errors.first('step-1.phoneNumber') }}</p>
                                                                    </div>
                                                                </div>
                                                                <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"></div> -->
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.adviceArea && configureFields.adviceArea.include && configureFields.adviceArea.include === true">
                                                            <div class="input-group">
                                                                <label class="template-label" for="adviceArea">{{adviceArea.labelName}}<span class="required-symbol" v-if="checkAndValidate1('adviceArea')"> *</span></label>
                                                                <select
                                                                    v-validate="`${checkAndValidate1('adviceArea')}`"
                                                                    class="form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown"
                                                                    v-model="dynamicFields.adviceArea"
                                                                    name="adviceArea"
                                                                    :aria-required="checkAndValidate1('adviceArea') ? 'true' : 'false'"
                                                                    id="adviceArea"
                                                                    data-vv-validate-on="change|blur"
                                                                >
                                                                    <option value="" selected disabled style="display:none">Select Area</option>
                                                                    <option v-for="role in adviceArea.memberValue" :key="role" :value="role.trim()">{{role.trim()}}</option>
                                                                </select>
                                                                <p v-show="errors.has('step-1.adviceArea')" class="error">{{ errors.first('step-1.adviceArea') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17" v-if="configureFields.linkedInProfile && configureFields.linkedInProfile.include && configureFields.linkedInProfile.include === true">
                                                            <div class="input-group">
                                                                <label class="template-label" for="linkedInProfile">{{configureFields.linkedInProfile.labelName}}<span class="required-symbol" v-if="checkAndValidate1('linkedInProfile')"> *</span></label>
                                                                <input
                                                                    type="text"
                                                                    class="form-control input-value pt-input input-focus"
                                                                    v-model="dynamicFields.linkedInProfile"
                                                                    id="linkedInProfile"
                                                                    name="linkedInProfile"
                                                                    v-bind:class="{'request-form-error-border': errors.has('linkedInProfile') }"
                                                                    v-validate="{ required: configureFields.linkedInProfile.require == true ? true: false, regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/ }"
                                                                    data-vv-validate-on="change"
                                                                    :aria-required="checkAndValidate1('linkedInProfile') ? 'true' : 'false'"
                                                                    @input="e => dynamicFields.linkedInProfile = sanitizeUrl(e.target.value)"
                                                                >
                                                                <p v-show="errors.has('step-1.linkedInProfile')" class="error">{{ errors.first('step-1.linkedInProfile') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.college && configureFields.college.include && configureFields.college.include === true">
                                                            <div class="input-group">
                                                                <label class="template-label" for="college">{{configureFields.college.labelName}}<span class="required-symbol" v-if="checkAndValidate1('college')"> *</span></label>
                                                                <input
                                                                    type="text"
                                                                    class="form-control input-value pt-input input-focus"
                                                                    id="college"
                                                                    v-model="dynamicFields.college"
                                                                    name="college"
                                                                    v-validate.continues="`${checkAndValidate1('college')}`"
                                                                    v-bind:class="{'request-form-error-border': errors.has('step-1.college') }"
                                                                    data-vv-validate-on="change"
                                                                    :aria-required="checkAndValidate1('college') ? 'true' : 'false'"
                                                                    @input="e => dynamicFields.college = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                v-show="errors.has('step-1.college')"
                                                                class="error"
                                                                >{{ errors.first('step-1.college') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.college2 && configureFields.college2.include && configureFields.college2.include === true">
                                                            <div class="input-group">
                                                                <label class="template-label" for="college2">{{configureFields.college2.labelName}}<span class="required-symbol" v-if="checkAndValidate1('college2')"> *</span></label>
                                                                <select
                                                                    data-vv-validate-on="change|blur"
                                                                    id="college2"
                                                                    v-validate="`${checkAndValidate1('college2')}`"
                                                                    class="form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown"
                                                                    v-model="dynamicFields.college2"
                                                                    name="college2"
                                                                    :aria-required="checkAndValidate1('college2') ? 'true' : 'false'"
                                                                >
                                                                    <option value="" selected disabled style="display:none">Select {{configureFields.college2.labelName}}</option>
                                                                    <option v-for="(degree, idx) in college2.memberValue" :key="`college-${idx}`" :value="degree.trim()">{{degree.trim()}}</option>
                                                                </select>
                                                                <p
                                                                v-show="errors.has('step-1.college2')"
                                                                class="error"
                                                                >{{ errors.first('step-1.college2') }}</p>
                                                            </div>
                                                        </div>
                                                        <!-- Major (Dropdown - multi select via chips) -->
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.major && configureFields.major.include && configureFields.major.include === true">
                                                            <div class="input-group">
                                                                <label class="template-label" for="major">{{configureFields.major.labelName}}<span class="required-symbol" v-if="checkAndValidate1('major')"> *</span></label>
                                                                <select
                                                                    id="major"
                                                                    class="form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown"
                                                                    v-model="selectedMajorTemp"
                                                                    name="majorSelect"
                                                                    :aria-required="checkAndValidate1('major') ? 'true' : 'false'"
                                                                    data-vv-validate-on="change|blur"
                                                                    @change="onMajorSelect"
                                                                >
                                                                    <option value="" selected disabled style="display:none">Select {{configureFields.major.labelName}}</option>
                                                                    <option v-for="(m, idx) in major.memberValue" :key="`major-${idx}`" :value="m.trim()">{{m.trim()}}</option>
                                                                </select>
                                                                <!-- Hidden input for validation; bind value not model to avoid computed setter -->
                                                                <input type="hidden" name="major" :value="majorJoined" v-validate="`${checkAndValidate1('major')}`" data-vv-validate-on="change|blur" :aria-describedby="checkAndValidate1('major') ? 'required-note' : null" />
                                                                <p v-show="errors.has('step-1.major')" class="error">{{ errors.first('step-1.major') }}</p>
                                                                <!-- Major limit message removed per request -->
                                                                <div v-if="dynamicFields.major && dynamicFields.major.length" class="selected-chips">
                                                                      <span v-for="m in dynamicFields.major" :key="`major-chip-${m}`" class="chip">{{ m }}
                                                                          <button type="button" class="chip-close" :aria-label="'Remove ' + m" @click.stop="removeMajorByValue(m)">×</button>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.classYear && configureFields.classYear.include && configureFields.classYear.include === true">
                                                            <div class="input-group">
                                                                <label class="template-label" for="year">{{configureFields.classYear.labelName}}<span class="required-symbol" v-if="checkAndValidate1('year')"> *</span></label>
                                                                <input
                                                                    type="text"
                                                                    class="form-control input-value pt-input input-focus"
                                                                    id="year"
                                                                    v-model="dynamicFields.year"
                                                                    name="year"
                                                                    v-validate.continues="`${checkAndValidate1('year')}`"
                                                                    v-bind:class="{'request-form-error-border': errors.has('step-1.year') }"
                                                                    data-vv-validate-on="change"
                                                                    :aria-required="checkAndValidate1('year') ? 'true' : 'false'"
                                                                    @input="e => dynamicFields.year = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                v-show="errors.has('step-1.year')"
                                                                class="error"
                                                                >{{ errors.first('step-1.year') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.classYear2 && configureFields.classYear2.include && configureFields.classYear2.include === true">
                                                            <div class="input-group">
                                                                <label class="template-label" for="year2">{{configureFields.classYear2.labelName}}<span class="required-symbol" v-if="checkAndValidate1('year2')"> *</span></label>
                                                                <select
                                                                    id="year2"
                                                                    v-validate="`${checkAndValidate1('year2')}`"
                                                                    class="form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown"
                                                                    v-model="dynamicFields.year2"
                                                                    name="year2"
                                                                    :aria-required="checkAndValidate1('year2') ? 'true' : 'false'"
                                                                    data-vv-validate-on="change|blur"
                                                                >
                                                                    <option value="" selected disabled style="display:none">Select {{configureFields.classYear2.labelName}}</option>
                                                                    <option v-for="(year,idx) in classYear2.memberValue" :key="`year-${idx}`" :value="year.trim()">{{year.trim()}}</option>
                                                                </select>
                                                                <p
                                                                v-show="errors.has('step-1.year2')"
                                                                class="error"
                                                                >{{ errors.first('step-1.year2') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.organization && configureFields.organization.include && configureFields.organization.include === true">
                                                            <div class="input-group">
                                                                <label class="template-label" for="organization">{{configureFields.organization.labelName}}<span class="required-symbol" v-if="checkAndValidate1('organization')"> *</span></label>
                                                                <input
                                                                    type="text"
                                                                    class="form-control input-value pt-input input-focus"
                                                                    id="organization"
                                                                    v-model="dynamicFields.organization"
                                                                    name="organization"
                                                                    v-validate.continues="`${checkAndValidate1('organization')}`"
                                                                    v-bind:class="{'request-form-error-border': errors.has('step-1.organization') }"
                                                                    data-vv-validate-on="change"
                                                                    :aria-required="checkAndValidate1('organization') ? 'true' : 'false'"
                                                                    @input="e => dynamicFields.organization = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                v-show="errors.has('step-1.organization')"
                                                                class="error"
                                                                >{{ errors.first('step-1.organization') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.title && configureFields.title.include && configureFields.title.include === true">
                                                            <div class="input-group">
                                                                <label class="template-label" for="role">{{configureFields.title.labelName}}<span class="required-symbol" v-if="checkAndValidate1('role')"> *</span></label>
                                                                <input
                                                                    type="text"
                                                                    class="form-control input-value pt-input input-focus"
                                                                    v-model="dynamicFields.role"
                                                                    id="role"
                                                                    name="role"
                                                                    v-validate.continues="`${checkAndValidate1('role')}`"
                                                                    v-bind:class="{'request-form-error-border': errors.has('step-1.role') }"
                                                                    data-vv-validate-on="change"
                                                                    :aria-required="checkAndValidate1('role') ? 'true' : 'false'"
                                                                    @input="e => dynamicFields.role = sanitizeInput(e.target.value)"
                                                                    >
                                                                <p
                                                                v-show="errors.has('step-1.role')"
                                                                class="error"
                                                                >{{ errors.first('step-1.role') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.studentId && configureFields.studentId.include && configureFields.studentId.include === true">
                                                            <div class="input-group">
                                                                <label class="template-label" for="studentId">{{configureFields.studentId.labelName}}<span class="required-symbol" v-if="checkAndValidate1('studentId')"> *</span></label>
                                                                <input
                                                                    type="text"
                                                                    class="form-control input-value pt-input input-focus"
                                                                    v-model="dynamicFields.studentId"
                                                                    id="studentId"
                                                                    name="studentId"
                                                                    v-validate.continues="`${checkAndValidate1('studentId')}`"
                                                                    v-bind:class="{'request-form-error-border': errors.has('step-1.studentId') }"
                                                                    data-vv-validate-on="change"
                                                                    :aria-required="checkAndValidate1('studentId') ? 'true' : 'false'"
                                                                    @input="e => dynamicFields.studentId = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                v-show="errors.has('step-1.studentId')"
                                                                class="error"
                                                                >{{ errors.first('step-1.studentId') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17" v-if="configureFields.dueDate && configureFields.dueDate.include && configureFields.dueDate.include === true">
                                                            <div class="input-group">
                                                                <label class="template-label" for="dueDate">{{configureFields.dueDate.labelName}}<span class="required-symbol" v-if="checkAndValidate1('dueDate')"> *</span></label>
                                                                <datepicker
                                                                    id="dueDate"
                                                                    name="dueDate"
                                                                    class="input-focus template-input-date-picker accessible-datepicker"
                                                                    v-model="dynamicFields.dueDate"
                                                                    v-bind:class="{'request-form-error-border': errors.has('step-1.dueDate') }"
                                                                    :format="DatePickerFormat"
                                                                    :disabledDates="disabledDates"
                                                                    v-validate.continues="`${checkAndValidate1('dueDate')}`"
                                                                    data-vv-validate-on="change|blur"
                                                                    ref="accessibleDatepicker"
                                                                ></datepicker>
                                                                <p class="helper-text template-label mb-0-custom"><strong>Note:</strong> Does your request have an expiration date after which an answer is no longer desirable?</p>
                                                                <p
                                                                v-show="errors.has('step-1.dueDate')"
                                                                class="error"
                                                                >{{ errors.first('step-1.dueDate') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12 mb-17 magic-wand-field-col" :style="magicWandThemeStyle">
                                                            <div class="text-container-placeholder input-group template-input-text-area template-textarea-v3-t2 magic-wand-icon">
                                                                <label for="prompt" class="template-label">{{configureFields.question.labelName}}</label><span class="required-symbol"> *</span>
                                                                <div class="error-message-textarea error" v-show="errors.has('step-1.prompt')">{{errors.first('step-1.prompt')}}</div>
                                                                <div class="char-counter-input" >
                                                                    <span aria-live="polite"><span v-bind:class="{'char-count-error': underMinCount}">{{ textCount }}</span>  / {{ textMax }} <span class="sr-only"> character count.</span></span>
                                                                </div>
                                                                <div v-html="this.requestForm.question" @click="handlePlaceholderClick" class="placeholder-overlay input-group pd-remove unsubscribe-height input-focus request-form-question-container template-input-text-area common-question-textarea-for-v1-v2" :class="{ 'magicwand-enabled': !magicWandEnabled }" :style="placeholderStyle"></div>
                                                                <div class="textarea-magic-container magic-wand-field-input magic-wand-icon">
                                                                <textarea
                                                                    class="form-control pt-input request-form-question-textarea "
                                                                    id="prompt"
                                                                    aria-label="Question"
                                                                    v-model="ask.text"
                                                                    name="prompt"
                                                                    rows="15"
                                                                    :maxlength="textMax"
                                                                    :aria-required="true"
                                                                    v-on:input="countdown"
                                                                    v-bind:class="{'request-form-error-border question-error-present': errors.has('step-1.prompt') }"
                                                                    @focus="handleQuestionFocusEvent"
                                                                    @blur="handleQuestionBlurEvent"
                                                                    ref="questionPlaceholderRef"
                                                                    v-validate.continues="'required|max:2000|min:200'"
                                                                    data-vv-validate-on="change|blur"
                                                                    aria-live="polite"
                                                                    :style="!magicWandEnabled ? 'padding: 8px !important': 'padding: 37px 8px 8px 8px !important'"
                                                                    @input="e => ask.text = sanitizeInput(e.target.value)"
                                                                ></textarea>
                                                                <a v-if="magicWandEnabled"
                                                                    role="button"
                                                                    aria-label="View Examples"
                                                                    href="javascript:void(0);"
                                                                    @click.prevent="toggleMagicWandExamples('text')"
                                                                    class="magic-wand-link-textarea magic-wand-link-accent"
                                                                    :class="{'magic-wand-link-active': isExamplesOpen('text')}"
                                                                >View Examples
                                                                    <img :src="magicWandIcon" class="magic-wand-img magic-wand-img-panel" alt="" width="20" height="20">
                                                                </a>
                                                            </div>
                                                            </div>
                                                            <div v-if="magicWandEnabled && isExamplesOpen('text')" class="magic-wand-examples-anchor">
                                                                <MagicWandExamplesPanel
                                                                    :examples="getWizardExamplesForField('text')"
                                                                    :field-label="getMagicWandFieldLabel('text')"
                                                                    :loading="wizardExamplesLoading"
                                                                    :magic-wand-icon="magicWandIcon"
                                                                    :accent-color="magicWandAccentColor"
                                                                    :field-has-text="magicWandFieldHasText('text')"
                                                                    @close="closeMagicWandExamples"
                                                                    @use-example="insertMagicWandExample('text', $event)"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17" v-if="configureFields.referrer && configureFields.referrer.include && configureFields.referrer.include === true">
                                                            <div class="input-group">
                                                                <label class="template-label" for="referrer">{{configureFields.referrer.labelName}}<span class="required-symbol" v-if="checkAndValidate1('referrer')"> *</span></label>
                                                                <input
                                                                    type="text"
                                                                    id="referrer"
                                                                    class="form-control input-value pt-input input-focus"
                                                                    v-model="dynamicFields.referrer"
                                                                    name="referrer"
                                                                    placeholder=""
                                                                    v-validate.continues="`${checkAndValidate1('referrer')}`"
                                                                    :aria-required="checkAndValidate1('referrer') ? 'true' : 'false'"
                                                                    v-bind:class="{'request-form-error-border': errors.has('step-1.referrer') }"
                                                                    data-vv-validate-on="change"
                                                                    @input="e => dynamicFields.referrer = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                class="error"
                                                                v-show="errors.has('step-1.referrer')"
                                                                >{{errors.first('step-1.referrer')}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.referrer2 && configureFields.referrer2.include && configureFields.referrer2.include === true">
                                                            <div class="input-group">
                                                                <label class="template-label" for="referrer2">{{configureFields.referrer2.labelName}}<span class="required-symbol" v-if="checkAndValidate1('referrer2')"> *</span></label>
                                                                <select
                                                                    id="referrer2"
                                                                    v-validate="`${checkAndValidate1('referrer2')}`"
                                                                    class="form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown"
                                                                    v-model="dynamicFields.referrer2"
                                                                    name="referrer2"
                                                                    :aria-required="checkAndValidate1('referrer2') ? 'true' : 'false'"
                                                                    data-vv-validate-on="change|blur"
                                                                >
                                                                    <option value="" selected disabled style="display:none">Select</option>
                                                                    <option v-for="(degree, idx) in referrer2.memberValue" :key="`referrer-${idx}`" :value="degree.trim()">{{degree.trim()}}</option>
                                                                </select>
                                                                <p
                                                                    v-show="errors.has('step-1.referrer2')"
                                                                    class="error"
                                                                >{{ errors.first('step-1.referrer2') }}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mlr0" v-if="configureFields.disclaimer && configureFields.disclaimer.include && configureFields.disclaimer.include === true">
                                                        <div class="form-group disclaimer">
                                                            <md-checkbox
                                                                tabindex="1"
                                                                name="disclaimer"
                                                                id="disclaimer"
                                                                v-model="dynamicFields.disclaimer"
                                                                @change="updateDisclaimer()"
                                                                class="form-control template-checkbox pt-0"
                                                                data-vv-validate-on="change"
                                                                v-validate.continues="`${checkAndValidate1('disclaimer')}`"
                                                                >
                                                                {{ configureFields.disclaimer.labelName }}
                                                                <span class="required-symbol" v-if="checkAndValidate1('disclaimer')"> *</span>
                                                            </md-checkbox>

                                                            <p
                                                                v-show="errors.has('step-1.disclaimer')"
                                                                class="error error-mt-2 template-checkbox-error"
                                                            >{{ errors.first('step-1.disclaimer') }}</p>
                                                        </div>
                                                    </div>
                                                    <div class="template-mb-35" v-if="configureFields.disclaimer && configureFields.dueDate.include === false"></div>
                                                    <div class="text-center-xs float-right">
                                                    <template v-if="!communityHasInterests">
                                                        <md-button
                                                                type="button"
                                                                class="btn btn_info template-review-submit template-button"
                                                                :disabled="loading"
                                                                aria-label="Next."
                                                                :aria-busy="loading"
                                                                @click="onClick"
                                                                :style="styleSubmitBtn">
                                                                Next
                                                        </md-button >
                                                </template>
                                                <template v-else>
                                                        <div class="btn-block text-right mlr0 text-center-xs">
                                                            <md-button type="submit" @click="onClick" :style="styleSubmitBtn" class="btn_info template-review-submit template-button">Next</md-button>
                                                        </div>
                                                    </template>
                                                </div>

                                                </form>
                                        </div>
                                        <div class="tab_inn" v-if="isSecondPage">
                                            <h1 id="closeup-header" class="template-title">Ready for your close-up?</h1>
                                            <p class="box-sub-heading mb35 custom-content request-form-title-anchor-tab" v-if="community.content && community.content.requestFormWizardPage3" v-html="sanitizeListHTML(community.content.requestFormWizardPage3)"></p>
                                            <p class=" box-sub-heading mb35 custom-content request-form-title-anchor-tab" v-else >Here's what advisors will receive. Need to make a revision? Simply click "Back" and edit.</p>
                                            <hr class="template-hr-custom" />
                                            <div class="about-feedbackreq">
                                            <div class="template-request-review">
                                                <h2 aria-level="2" role="Presentation">{{this.ask.first}} {{this.ask.last}}</h2>
                                                <h5 aria-level="3" role="Presentation" style="color:#000001;">{{this.ask.dynamicFields.college && this.ask.dynamicFields.college != "" ? this.ask.dynamicFields.college : (this.ask.dynamicFields.college2 && this.ask.dynamicFields.college2 != "" ? this.ask.dynamicFields.college2 : '')}}</h5>
                                                <h2 aria-level="2" role="Presentation">{{this.ask.subject}}</h2>
                                                <p class="font-color">{{this.ask.text}}</p>
                                            </div>
                                            <div class="row back-next-step-2">
                                                <div class="col-lg-6 col-md-6 col-sm-6 text-center-xs float-left">
                                                    <button
                                                        tabindex="0"
                                                        class="btn btn_info template-review-edit template-button mb-10"
                                                        :style="styleEditBtn"
                                                        @click="goToFirst()"
                                                        role="button"
                                                    >Back</button>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 text-center-xs float-right">
                                                    <md-button type="button" :disabled="disabledBtn == 1 ? true : false"  :style="styleSubmitBtn"  class="btn btn_info template-review-submit template-button" @click="save()">Submit</md-button>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        <div class='tab_inn' v-if="isThirdPage && configureFields.interest && configureFields.interest.include">
                                            <h1 id="interests-header" class="template-title" tabindex="-1">Choose 3-5 interests you have.</h1>
                                            <p class="box-sub-heading mb35 custom-content interest-description-display">{{configureFields.interest.description}}</p>
                                            <fieldset>
                                                <legend class="sr-only">Select your interests</legend>
                                            <div class="row text-center interest-container">
                                                <div
                                                    v-for="randomInterestItem in randomInterest"
                                                    :key="randomInterestItem"
                                                    class="col-md-4 col-sm-4 col-xs-6 width100"
                                                    ref="checkboxMainRef"
                                                >
                                                    <md-checkbox
                                                        class="my-round-checkbox"
                                                        v-model="selectedInterestList"
                                                        :value="randomInterestItem"
                                                        :name="randomInterestItem"
                                                        @change="updateAriaChecked(randomInterestItem)"
                                                        :aria-describedby="`interest-desc-${randomInterestItem.replace(/\s+/g, '-').toLowerCase()}`"
                                                    >
                                                        <span :id="`interest-desc-${randomInterestItem.replace(/\s+/g, '-').toLowerCase()}`">{{randomInterestItem}}</span>
                                                    </md-checkbox>
                                                </div>
                                            </div>
                                            </fieldset>
                                            <div class="row back-next-step-2 pr-25 pl-25">
                                                <div class="text-center-xs float-left">
                                                  <button
                                                        tabindex="0"
                                                        class="btn btn_info template-review-edit template-button mb-10"
                                                        :style="styleEditBtn"
                                                        @click="goToFirst()"
                                                        role="button">Back
                                                  </button>
                                                </div>
                                                <div class="text-center-xs float-right">
                                                    <button type="button"
                                                            class="btn btn_info template-review-submit template-button"
                                                            :disabled="loading"
                                                            aria-label="Next: We're crafting a thoughtful question to present to your advisor. Clickable"
                                                            :aria-busy="loading"
                                                            @click="goToFourth()"
                                                            :style="styleSubmitBtn">
                                                            Next
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class='tab_inn' v-if="isFourthPage && athenaEnabledQC">
                                            <h1 id="athenaQuestion-header" class="template-title">What do you think?</h1>
                                            <p class="box-sub-heading mb35 custom-content interest-description-display">We've crafted a question for you based on what you shared.<br></p>
                                            <template v-if="loading">
                                                <div class="row">
                                                <AthenaQuestionSkeleton :is-visible="loading" />
                                            </div>
                                            </template>
                                            <template v-else>
                                                <div class="round-question-container">
                                                <h2 class="template-content-bold">{{ dynamicFields.first }} {{ dynamicFields.last }}</h2>
                                                <tr>
                                                    <td  role="Presentation" class="fs_15 lh_111" style="font-family:'Roboto',Helvetica Neue,Helvetica,Arial,sans-serif; text-align:left; font-size:18px; color:#000001; line-height:16px;">
                                                    <span v-if="dynamicFields.college || dynamicFields.college2  || school">{{dynamicFields.college|| dynamicFields.college2 ||  school }}</span>
                                                    <span v-if="dynamicFields.year || dynamicFields.year2 || year"> ({{dynamicFields.year || dynamicFields.year2 || year }})</span>
                                                    </td>
                                                </tr>
                                                <br>
                                                <p v-if="gaiaAnswer && !isEditing" class="custom-content-2" v-html="sanitizeInput(gaiaFormattedAnswer)"></p>
                                                <textarea v-else type="text" v-model="gaiaAnswer" class="editable-input custom-content-2" style="text-align: justify;" rows="15" aria-label="Edit your question response"></textarea>
                                            </div>
                                            <div class="row back-next-step-2 pr-25 pl-25">
                                                <div class="text-center-xs float-left" style="display: flex; gap: 30px;">
                                                    <button
                                                        v-if="!isEditing"
                                                        :aria-label="isUndo ? 'Undo' : 'Redo'"
                                                        class="btn btn_info template-review-edit template-button mb-10"
                                                        :style="styleEditBtn"
                                                        @click="toggleQuestionVersion()"
                                                        role="button"
                                                        >
                                                        {{  isUndo ? 'Undo': 'Redo' }}
                                                  </button>
                                                  <button
                                                        class="btn btn_info template-review-edit template-button mb-10"
                                                        :style="styleEditBtn"
                                                        @click="toggleEdit()"
                                                        role="button"
                                                        >
                                                        {{ isEditing ? 'Save' : 'Edit' }}
                                                  </button>
                                                </div>
                                                <div class="text-center-xs float-right">
                                                    <template>
                                                        <button v-if="!isEditing"
                                                                type="button"
                                                                class="btn_info template-review-submit template-button"
                                                                :style="styleSubmitBtn"
                                                                :disabled="isEditing"
                                                                aria-label="Submit your question."
                                                                :aria-busy="loading"
                                                                @click="updateAndSubmit()">
                                                                Submit
                                                        </button>
                                                        </template>
                                                </div>
                                            </div>
                                            </template>
                                        </div>
                                        <div class='tab_inn' v-if="isFourthPage && questionCoachEnabled">
                                            <h1 id="closeup-header" class="template-title">Great Start</h1>
                                            <p class=" box-sub-heading mb35 custom-content request-form-title-anchor-tab">We've analyzed your question and have a few suggestions to make sure you'll get a response.</p>
                                            <hr class="template-hr-custom" />
                                            <div class="about-feedbackreq">
                                                <div v-if="questionCoachScore <= 0">
                                                    <MidsizeSkeleton :is-visible="true" />
                                                </div>

                                                <div v-else class="template-request-review feedback-card"  :style="{ backgroundColor: feedback.color + ' !important' }">
                                                <div class="feedback-content">
                                                    <h2 class="coach-header score-header feedback-title">
                                                        {{ feedback.text }}
                                                    </h2>
                                                    <p>{{ coachFeedback.guidance }}</p>


                                                    <!-- Checklist Display -->
                                                    <ul v-if="coachChecklist" class="feedback-checklist">
                                                        <li
                                                            v-for="(item, index) in checklistItems"
                                                            :key="item.key"
                                                            class="checklist-item"
                                                            :class="{ 'checked': item.checked, 'unchecked': !item.checked }"
                                                        >
                                                            <span class="checkbox-icon" :class="{ 'checked': item.checked }">
                                                                <svg v-if="item.checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <rect width="20" height="20" rx="4" fill="#10B981"/>
                                                                    <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                </svg>
                                                                <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <rect width="20" height="20" rx="4" fill="#E5E7EB" stroke="#D1D5DB" stroke-width="1"/>
                                                                </svg>
                                                            </span>
                                                            <span class="checklist-text" :class="{ 'text-muted': !item.checked }">{{ item.label }}</span>
                                                        </li>
                                                    </ul>

                                                    <!-- Improvements Section (shown when not all items complete) -->
                                                    <div v-if="coachChecklist && !isMessageReady && coachFeedback.improvements && coachFeedback.improvements.length" class="improvements-section">
                                                        <h3 class="improvements-title">Suggestions to improve:</h3>
                                                        <ul class="improvements-list">
                                                            <li
                                                                v-for="(improvement, index) in coachFeedback.improvements"
                                                                :key="'improvement-' + index"
                                                                class="improvement-item"
                                                            >
                                                                {{ improvement }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="feedback-emoji-wrapper">
                                                    <div class="score-circle" v-if="coachChecklist">
                                                        <svg width="80" height="80" viewBox="0 0 80 80">
                                                            <circle cx="40" cy="40" r="35" fill="white" stroke="#E5E7EB" stroke-width="2"/>
                                                            <text x="40" y="45" text-anchor="middle" font-size="24" font-weight="bold" fill="#1F2937">
                                                                {{ checklistCompletionCount }}/{{ checklistTotalCount }}
                                                            </text>
                                                            <text x="40" y="58" text-anchor="middle" font-size="10" fill="#6B7280">
                                                                COMPLETE
                                                            </text>
                                                        </svg>
                                                    </div>
                                                    <span class="feedback-emoji big-emoji" v-else>{{ feedback.emoji }}</span>
                                                    <span class="feedback-text-emoji">{{ feedback.text_emoji }}</span>
                                                </div>
                                            </div>
                                            <label for="askText">Edit your message below - and review changes</label>
                                                <textarea type="text" v-model="ask.text" class="editable-input custom-content-2" style="text-align: justify;" rows="15" aria-label="Edit your question response"></textarea>
                                                <div class="back-next-step-2"
                                                    style="display: flex; justify-content: space-between; align-items: center; gap: 10px; flex-wrap: nowrap;">
                                                <button class="btn btn_info template-review-edit template-button"
                                                        :style="styleEditBtn"
                                                        @click="communityHasInterests ? goToThird() : goToPage(1,0)"
                                                        role="button">
                                                    Back
                                                </button>

                                                <div style="display: flex; gap: 10px;">
                                                    <button class="btn btn_info template-review-edit template-button"
                                                        :style="styleEditBtn"
                                                        @click="questionCoach()"
                                                        role="button">
                                                    Review
                                                </button>
                                                    <md-button type="button"
                                                            :disabled="!isMessageReady"
                                                            :style="styleSubmitBtn"
                                                            class="btn btn_info template-review-submit template-button"
                                                            @click="save()">
                                                    Submit
                                                    </md-button>
                                                </div>
                                                </div>
                                        </div>
                                        </div>
                                        <div class='tab_inn' v-else-if="isFourthPage && !athenaEnabledQC">
                                            <h1 id="closeup-header" class="template-title">Ready for your close-up?</h1>
                                            <p class="box-sub-heading mb35 custom-content request-form-title-anchor-tab" v-if="community.content && community.content.requestFormWizardPage3" v-html="sanitizeListHTML(community.content.requestFormWizardPage3)"></p>
                                            <p class=" box-sub-heading mb35 custom-content request-form-title-anchor-tab" v-else >Here's what advisors will receive. Need to make a revision? Simply click "Back" and edit.</p>
                                            <hr class="template-hr-custom" />
                                            <div class="about-feedbackreq">
                                                <div class="template-request-review">
                                                <h2 aria-level="2" role="Presentation">{{dynamicFields.first}} {{dynamicFields.last}}</h2>
                                                <tr>
                                                    <td  role="Presentation" class="fs_15 lh_111" style="font-family:'Roboto',Helvetica Neue,Helvetica,Arial,sans-serif; text-align:left; font-size:18px; color:#777479; line-height:22px;">
                                                    <span v-if="dynamicFields.college || dynamicFields.college2  || school">{{dynamicFields.college|| dynamicFields.college2 ||  school }}</span>
                                                    <span v-if="dynamicFields.year || dynamicFields.year2 || year"> ({{dynamicFields.year || dynamicFields.year2 || year }})</span>
                                                    </td>
                                                </tr>
                                                <br>
                                                <p class="font-color">{{this.ask.text}}</p>
                                            </div>
                                            <div class="row back-next-step-2">
                                                <div class="col-lg-6 col-md-6 col-sm-6 text-center-xs float-left">
                                                    <button class="btn btn_info template-review-edit template-button mb-10" :style="styleEditBtn" @click="communityHasInterests ? goToThird() : goToPage(1,0)" role="button">Back</button>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 text-center-xs float-right text-right-md">
                                                    <md-button type="button"  :style="styleSubmitBtn"  class="btn btn_info template-review-submit template-button" @click="save()">Submit</md-button>
                                                </div>
                                            </div>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="!isBeforeRequest && !invalidMember">
                                <div class='header-text common-space-from-logo text-center unsubscribepage-thankumsg darken-request-confirmation'>
                                    <h1
                                        class="box-heading thankyou-template-title"
                                        id="whatsnext-header"
                                    >
                                        So what's next?
                                    </h1>
                                    <div style="color:#000001;">
                                        <div
                                            v-if="community.content && community.content.requestPageThankYou"
                                            class="box-sub-heading text-left content-textleft thankyou-custom-content"
                                            tabindex="0"
                                            @click.capture="handleThankYouResourceClick"
                                            v-html="sanitizeListHTML(community.content.requestPageThankYou)"
                                        ></div>
                                        <div
                                            v-else
                                            class="box-sub-heading text-left content-textleft thankyou-custom-content"
                                            tabindex="0"
                                        >
                                            We will now recruit the right experts to help you.
                                        </div>

                                        <div v-if="isLoadingResources" class="thankyou-loader-wrapper mt-4" aria-live="polite">
                                            <CustomThankYouSkeleton :is-visible="true" />
                                        </div>

                                        <div
                                            v-if="showErrorMessage"
                                            class="thankyou-status-message mt-4"
                                            role="alert"
                                            tabindex="0"
                                            style="padding: 12px 16px; border-radius: 4px; border: 1px solid #f5c2c7; background: #f8d7da; color: #611a15;"
                                        >
                                            {{ errorMessage || 'We were unable to submit your request. Please try again.' }}
                                        </div>

                                        <div class="mt-4 text-left" v-if="showSuccessMessage">
                                            <br>
                                            <button
                                                type="button"
                                                :style="styleSubmitBtn"
                                                class="btn btn_info template-review-submit template-button"
                                                @click="askAnotherQuestion"
                                            >
                                                Ask Another Question
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="!isBeforeRequest && invalidMember">
                                <div class='header-text common-space-from-logo text-left unsubscribepage-thankumsg'>
                                    <h1 class="box-heading thankyou-template-title">Ooops. We're really sorry.</h1>
                                    <div v-if="community.content && community.content.requestPageThankYou" class="box-sub-heading text-left content-textleft thankyou-custom-content" v-html="sanitizeListHTML(finalInvalidMemberMessage)"></div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <footer>
                        <ul class="list-inline text-center footer-links">
                            <li>
                                <a :href="community.content.landingPageURL" target="_blank" class="links" v-if="community.content && community.content.landingPageURL && community.content.landingPageURL.length" tabindex="0">Learn More</a>
                                <a href="javascript:void(0)" v-else tabindex="0">Learn More</a>
                            </li>
                            <li>
                                <a :href="community.content.termsConditionsURL" target="_blank" class="links" v-if="community.content && community.content.termsConditionsURL && community.content.termsConditionsURL.length" tabindex="0">Terms Of Use [pdf]</a>
                                <a href="javascript:void(0)" v-else tabindex="0">Terms Of Use [pdf]</a>
                            </li>
                            <li>
                                <a tabindex="0" :href="community.content.unsubscribePageURL" target="_blank" v-if="community.content && community.content.unsubscribePageURL && community.content.unsubscribePageURL.length">Opt Out</a>
                                <a href="javascript:void(0)" v-else>Opt Out</a>
                            </li>
                        </ul>
                        <div class="unsubscribe-community-logo">
                            <a :href="(community.content && community.content.landingPageURL) || 'https://www.protopia.co'" target="_blank"><img tabindex="0" :src="footerLogoURL" :alt="'Community Logo of '+ (community && community.content && community.content.parameter4 ? community.content.parameter4 : (community && community.name) || 'Community')"><span class="sr-only">Protopia - Visit our site</span></a>
                        </div>
                    </footer>
                </div>
            </div>
        </div>
    </div>
</template>


<!-- Script-->
<script>
import API, { GAIA_TIMEOUT_MS } from "../services/API";
import Member from "./Member";
import Datepicker from 'vuejs-datepicker';
import CustomSkeleton from './CustomSkeleton.vue';
import AthenaQuestionSkeleton from './AthenaQuestionSkeleton.vue';
import CustomThankYouSkeleton from "./CustomThankYouSkeleton.vue";
import Tooltip from './Tooltip';
import { getFooterURL, getLogoURL } from "../helpers/getCustomSettings";
import { getGaiaQuestion, saveGaiaAnswer } from "../helpers/getGaiaQuestion";
import { sanitizeInput, sanitizeHtmlTemplate, sanitizeResourceDescription, sanitizeUrl } from '../utils/sanitizer';
import { MajorFieldsMixin } from '../helpers/majorsHelper';
import { magicWandMixin } from '../mixins/magicWandMixin';
import MagicWandExamplesPanel from './MagicWandExamplesPanel.vue';
import EventBus from '../assets/js/EventBus';
import NotFound from "./NotFound.vue";
import Config from '../utils/config';
import MidsizeSkeleton from "./MidsizeSkeleton.vue";



export default {
    mixins: [MajorFieldsMixin, magicWandMixin],
    components: {
        Member,
        Datepicker,
        CustomSkeleton,
        AthenaQuestionSkeleton,
        MidsizeSkeleton,
        CustomThankYouSkeleton,
        NotFound,
        Tooltip,
        MagicWandExamplesPanel
    },
    props: ["community_id", "sourceparam"],
    data() {
        return {
            siteKey: Config.CAPTCHA_SITEKEY,
            isUndo: true,
            lastAnswer: '',
            requestText: "",
            captchaCalled: false,
            captchaScore: 0,
            magicWandEnabled: true,
            matchedResources: [],
            //Coach data
            questionCoachEnabled: false,
            questionCoachScore: 0,
            coachSessionID: "",
            coachSessionStarted: false,
            coachFeedback: "",
            coachUserInfo: "",
            coachChecklist: null,
            api: new API(),
            ask: {},
            community: {},
            athenaEnabledQC: true,
            isEditing: false,
            isFirstPage: true,
            isSecondPage: false,
            isThirdPage: false,
            isFourthPage: false,
            school: '',
            year: '',
            isSubjectRequired: false,
            fullPage: true,
            max: 2000,
            remainingCount: 0,
            prompt: "",
            isBeforeRequest: true,
            underMinCount: false,
            configureFields: {
            firstName: {
                labelName: ''
            },
            lastName: {
                labelName: ''
            },
            emailAddress: {
                labelName: ''
            },
            subject: {
                labelName: ''
            },
            question: {
                labelName: ''
            },
            referrer: {
                labelName: ''
            },
            referrer2: {
                labelName: ''
            }
            },
            dynamicFields: {
                major: [] // Initialize major as empty array
            },
            newAdmin: [],
            requestForm: {
                subjectLine: 'Short summary ...',
                question: "I have a question about ..."
            },
            submitBtn: {
                colorBackd: '#9178A0',
                color: '#ffffff'
            },
            editBtn: {
                colorBackd: '#CBA8E0',
                color: '#ffffff'
            },
            memberThankYou: "",
            DatePickerFormat: "MM/dd/yyyy",
            disabledDates: {
                to: new Date(Date.now() - 8640000)
            },
            logoURL: '',
            communityHasInterests: false,
            loading: false,
            footerLogoURL: "",
            gaiaQuestion: "",
            memberRole: {},
            adviceArea: {},
            college2: {},
            major: {},
            referrer2: {},
            selectedMajorTemp: '',
            // major limit UI removed
            gaiaAnswer: "",
            gaiaFormattedAnswer: "",
            newInterests: [],
            classYear2: {},
            channelType: "Request Form",
            memberInterestList: [],
            randomInterest: [],
            referenceInterest: [],
            selectedInterestList: [],
            askCreator: {},
            invalidMember: false,
            finalInvalidMemberMessage: "",
            minErrMsg: "Please expand on what you need help with ",
            showFormFlag: true,
            disabledBtn: 1,
            magicWandIcon: 'https://storage.googleapis.com/protopia/app/icons/wand.png',
            subjectCount: 0,
            bioCount: 0,
            textCount: 0,
            closeNicelyCount: 0,
            subjectMax: 100,
            bioMax: 500,
            textMax: 2000,
            closeNicelyMax: 250,
            circleId: '',
            actionPage: 'defPage',
            isSubmitting: false,
            placeholder: {
                questionPlaceholder: ''
            },
            placeholderStyle: {
                pointerEvents: ""
            },
            isShow: 0,
            isLoadingResources: false,
            thankYouTemplateRaw: '',
            resourcesHtml: '',
            loadingResourcesHtml: '',
            // loadingResourcesHtml: '<div class="thankyou-resources-loading" role="status" aria-live="polite">We\'re gathering resources for you…</div>',
            showSuccessMessage: false,
            showErrorMessage: false,
            errorMessage: '',
            createdAskId: '',
            pendingResourceClicks: {},
            // resourceHtml: ''
            autoFocus: false,
            showNotFound: false
        };
    },
    watch: {
        $route: "loadData",
        'ask.text': function(value) {
            if (value && String(value).trim().length > 0) {
                this.hideQuestionPlaceholder();
            }
        }
    },
    computed: {
        magicWandFieldConfig() {
            const label = this.configureFields && this.configureFields.question && this.configureFields.question.labelName
                ? this.configureFields.question.labelName
                : 'Question';
            return [{ field: 'text', key: 'wizard-prompts', label }];
        },
        isMessageReady() {
            // If checklist exists, enable submit when score is "good" (4+ items complete)
            if (this.coachChecklist) {
                const completionCount = Object.values(this.coachChecklist).filter(v => v === true).length;
                return completionCount >= 4;
            }
            // Fallback to score-based check
            return this.questionCoachScore >= 8;
        },
        checklistItems() {
            if (!this.coachChecklist) return [];
            const items = [
                {
                    key: 'introduction',
                    label: 'Add a greeting with brief context about why you\'re reaching out',
                    checked: this.coachChecklist.introduction
                },
                {
                    key: 'does_not_ask_for_job',
                    label: 'Ensure you are not asking for a job directly',
                    checked: this.coachChecklist.does_not_ask_for_job
                },
                {
                    key: 'asks_not_too_many',
                    label: 'Keep the message focused and well-structured',
                    checked: this.coachChecklist.asks_not_too_many
                },
                {
                    key: 'question_improved',
                    label: 'Make your question specific and easy to answer',
                    checked: this.coachChecklist.question_improved
                },
                {
                    key: 'thank_you',
                    label: 'End with a polite closing and thank you',
                    checked: this.coachChecklist.thank_you
                }
            ];
            return items;
        },
        checklistCompletionCount() {
            if (!this.coachChecklist) return 0;
            return Object.values(this.coachChecklist).filter(v => v === true).length;
        },
        checklistTotalCount() {
            if (!this.coachChecklist) return 0;
            return Object.keys(this.coachChecklist).length;
        },
        styleSubmitBtn() {
            return {
                'color': this.submitBtn.color,
                'background-color': this.submitBtn.colorBackd
            };
        },
        styleEditBtn() {
            return {
            'color': this.editBtn.color,
            'border-color': this.editBtn.colorBackd
            };
        },
        majorJoined() {
            const arr = Array.isArray(this.dynamicFields.major) ? this.dynamicFields.major : [];
            return arr.join(',');
        },
        feedback() {
        if (this.questionCoachScore == null) {
            return { text: "", color: "transparent" };
        }

        // If checklist exists and all items are true, show ready message
        if (this.coachChecklist) {
            const allChecklistItemsComplete = Object.values(this.coachChecklist).every(v => v === true);
            if (allChecklistItemsComplete) {
                return {
                    text: "Your message is ready to send!",
                    emoji: "🥳",
                    color: "#DFFAE2",
                    text_emoji: "Looking great!"
                };
            }
        }

        // Otherwise, use completion count to determine feedback
        const completionCount = this.checklistCompletionCount;
        const totalCount = this.checklistTotalCount;

        if (totalCount > 0) {
            // Checklist-based feedback
            if (completionCount === 0 || completionCount === 1) {
                return {
                    text: "Let's make this clearer together",
                    emoji: "🥺",
                    color: "#FDE7E9",
                    text_emoji: "Let's improve!"
                };
            } else if (completionCount === 2) {
                return {
                    text: "Let's make a few helpful tweaks",
                    emoji: "😉",
                    color: "#FFF3D8",
                    text_emoji: "Almost there!"
                };
            } else if (completionCount === 3) {
                return {
                    text: "Almost there! Just a couple adjustments",
                    emoji: "😄",
                    color: "#EAF6FF",
                    text_emoji: "On track!"
                };
            } else if (completionCount === 4) {
                return {
                    text: "Nice work! One small suggestion",
                    emoji: "🤩",
                    color: "#E7F8EE",
                    text_emoji: "Good!"
                };
            }
        }

        // Fallback to score-based system if no checklist
        const scoreMap = [
            {
                min: 0,
                max: 5.9,
                text: "Let's make this clearer together",
                emoji: "🥺",
                color: "#FDE7E9",
                text_emoji:"Let's improve!"
            },
            {
                min: 6,
                max: 6.9,
                text: "Let's make a few helpful tweaks",
                emoji: "😉",
                color: "#FFF3D8",
                text_emoji:"Almost there!"
            },
            {
                min: 7,
                max: 7.9,
                text: "Almost there! Just a couple adjustments",
                emoji: "😄",
                color: "#EAF6FF",
                text_emoji:"On track!"
            },
            {
                min: 8,
                max: 8.49,
                text: "Nice work! One small suggestion",
                emoji: "🤩",
                color: "#E7F8EE",
                text_emoji:"Good!"
            },
            {
                min: 8.5,
                max: 10,
                text: "Your message is ready to send!",
                emoji: "🥳",
                color: "#DFFAE2",
                text_emoji:"Looking great!"
            }
        ];

        const match = scoreMap.find(r => this.questionCoachScore >= r.min && this.questionCoachScore <= r.max);

        return match || { text: "Score out of range", color: "#e2e3e5" };
        },
    },
    // mounted() {
    //     this.$refs['firstName'].focus()
    // },
    mounted() {
        this.$nextTick(() => {
            const heading = document.getElementById('requestHelpHeader');
            if (heading) {
                heading.setAttribute('tabindex', '-1');
                heading.focus();
            }

            setTimeout(() => {
                this.loadCaptcha();
            }, 500);
        });

        // Add Escape key handler to close any open MD tooltips for keyboard users
        this._handleEscForTooltips = (e) => {
            if (e.key === 'Escape' || e.key === 'Esc') {
                // Material tooltip uses elements with class 'md-tooltip' and may add 'md-active' or inline styles
                const activeTooltips = document.querySelectorAll('.md-tooltip');
                activeTooltips.forEach(tp => {
                    // Try to hide by removing active classes and inline styles that make it visible
                    tp.classList.remove('md-active');
                    tp.style.display = 'none';
                    tp.style.visibility = 'hidden';
                    tp.style.opacity = '0';
                });

                // Also move focus back to the last focused tooltip trigger if possible
                const lastFocused = document.activeElement;
                if (lastFocused && lastFocused.classList && lastFocused.classList.contains('template-tooltip-span')) {
                    lastFocused.focus();
                }
            }
        };
        document.addEventListener('keydown', this._handleEscForTooltips);
    },
    beforeDestroy() {
        if (this._handleEscForTooltips) {
            document.removeEventListener('keydown', this._handleEscForTooltips);
            this._handleEscForTooltips = null;
        }
    },
    created() {
        var date = new Date();
        var AddDay = date.setDate(date.getDate() + 1);
        this.disabledDates.to = new Date(AddDay - 8640000);
        this.loadData();
        const dict = {
            custom: {
                email: {
                    required: () => "Please enter your email address",
                    email: () => "Please enter a valid email address"
                },
                first: {
                    required: () => "Please enter your first name"
                },
                last: {
                    required: () => "Please enter your last name"
                },
                title: {
                    required: () => "Please enter a subject line",
                    min: () => this.minErrMsg + '(minimum 10 characters).',
                    max: () => this.minErrMsg + '(maximum 100 characters).'
                },
                prompt: {
                    required: () => "Please enter your question",
                    max: () => "Prompt may not exceed 2000 characters",
                    min: () => this.minErrMsg + '(minimum 200 characters).'
                },
                college: {
                    required: () => "Please enter your college"
                },
                college2: {
                    required: () => "Please select your college"
                },
                year: {
                    required: () => "Please enter your class year"
                },
                major: {
                    required: () => "Please select your major"
                },
                year2: {
                    required: () => "Please select your class year"
                },
                role: {
                    required: () => "Please enter a title"
                },
                organization: {
                    required: () => "Please enter an organization"
                },
                studentId: {
                    required: () => "Please enter " + this.configureFields.studentId.labelName.toLowerCase()
                },
                dueDate: {
                    required: () => "Please enter valid date"
                },
                linkedInProfile: {
                    required: () => "Please enter linkedin profile url",
                    regex: () => "Please enter valid url"
                },
                phoneNumber: {
                    required: () => "Please enter phone number"
                },
                referrer: {
                    required: () => `Please enter about ${this.community.name} community`
                },
                referrer2: {
                    required: () => `Please select about ${this.community.name} community`
                },
                disclaimer: {
                    required: () => "Please check the above box."
                },
                memberRole: {
                    required: () => "Please select value."
                },
                adviceArea: {
                    required: () => "Please select value."
                },
                bio: {
                    required: () => "Field cannot be empty.",
                    min: () => this.minErrMsg + '(minimum 100 characters).'
                },
                closeNicely: {
                    required: () => "Field cannot be empty.",
                    min: () => this.minErrMsg + '(minimum 5 characters).'
                }
            }
        };
        // or use the instance method
        this.$validator.localize("en", dict);
    },
    methods: {
        focusHeading(id, delay = 300) {
            this.$nextTick(() => {
            setTimeout(() => {
                const heading = document.getElementById(id);
                if (heading) {
                heading.setAttribute('tabindex', '-1');
                heading.focus();
                }
            }, delay);
            });
        },
        loadCaptcha() {
            if (document.getElementById('recaptcha-script')) return;

            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.siteKey}`;
            script.async = true;
            script.defer = true;
            script.id = 'recaptcha-script';
            document.head.appendChild(script);
        },
        onClick(e) {
            if (this.captchaCalled) {
                this.handleNavigation('step-1');
                return;
            }

            e.preventDefault();
            /* eslint-disable no-undef */
            grecaptcha.enterprise.ready(async () => {
                try {
                    const token = await grecaptcha.enterprise.execute(this.siteKey, {action: 'SUBMIT'});
                    /* eslint-enable no-undef */
                    if (!token) throw new Error('Failed to generate token');

                    const response = await this.api.post("asks/recaptcha/", {token});
                    const { score } = response.data;
                    this.captchaScore = score || 0;
                    if (this.captchaScore > 0.5) {
                        this.captchaCalled = true;
                        this.handleNavigation('step-1');
                    } else {
                        this.$toast.error("Security verification failed, reload and try again.");
                    }
                } catch (error) {
                    console.error('Error during captcha verification:', error.message);
                }
            });
        },

        onMajorSelect() {
            const val = (this.selectedMajorTemp || '').trim();
            if (!val) return;
            if (!Array.isArray(this.dynamicFields.major)) this.dynamicFields.major = [];

            // Allow unlimited major selections
            if (!this.dynamicFields.major.includes(val)) {
                const next = [...this.dynamicFields.major, val].sort((a, b) => a.localeCompare(b));
                this.$set(this.dynamicFields, 'major', next);
            }
            this.selectedMajorTemp = '';
        },
        removeMajor(idx) {
            if (!Array.isArray(this.dynamicFields.major)) return;
            const next = this.dynamicFields.major
                .filter((_, i) => i !== idx)
                .sort((a, b) => a.localeCompare(b));
            this.$set(this.dynamicFields, 'major', next);
        },
        removeMajorByValue(value) {
            if (!Array.isArray(this.dynamicFields.major)) return;
            const next = this.dynamicFields.major
                .filter((v) => v !== value)
                .sort((a, b) => a.localeCompare(b));
            this.$set(this.dynamicFields, 'major', next);

            // Removing major; no explicit error flag to clear (flag removed)
        },

        handleNavigation(step) {
            if (this.communityHasInterests) {
                this.viewSecondPage(step);
            } else {
                this.goToFourth(step);
            }
        },
        normalizeArrayFields() {
            // Use cleanMajorFields for consistent major field processing
            this.cleanMajorFields();
        },

        loadData: async function() {
              this.showNotFound = false
              this.memberThankYou = '';
              try {
                const startTime = Date.now();
                localStorage.setItem('community_id', this.community_id);
                let fetchDataPromise = Promise.all([
                this.api.get(`communities/${this.community_id}/community-request${this.sourceparam ? '?sourceparam=' + this.sourceparam : ""}`).then(community => {
                    //this.communityHasInterests = this.community.content.interest.include;
                    this.community = community.data;
                    document.title = this.community.name + " | Get Help";
                    this.actionPage = this.community.actionPage
                    this.communityHasInterests = this.community.content && this.community.content.configureFields && this.community.content.configureFields.interest ? this.community.content.configureFields.interest.include : false;
                    const customSettings = this.community.customSettings;
                    if (customSettings && customSettings.faviconURL !== 'none') {
                        EventBus.$emit('change-favicon', customSettings.faviconURL);
                    }
                    this.questionCoachEnabled = this.community.content && this.community.content.questionCoachEnabled ? this.community.content.questionCoachEnabled : false;
                    this.magicWandEnabled = this.community.content && this.community.content.magicWandEnabled !== undefined ? this.community.content.magicWandEnabled : true;
                    this.athenaEnabledQC = this.community.content && this.community.content.athenaEnabledQC ? this.community.content.athenaEnabledQC : false;

                    // If the question coach is enabled, athena should be turned off.
                    this.athenaEnabledQC = this.questionCoachEnabled === true ? false: this.athenaEnabledQC;
                    this.channelType = this.community.friendlyNames && this.community.friendlyNames.requestForm ? this.community.friendlyNames.requestForm : "Request Form";
                    if (this.community.content && this.community.content.requestPageThankYou) {
                        let replaceStr = this.community.content.requestPageThankYou.replace(/\n/g, "<br />");
                        if (replaceStr.indexOf('ask.sourceparam') != -1) {
                            let re = new RegExp(`\\{\\{\\s?ask.sourceparam\\s?\\}\\}`, 'gi');
                            replaceStr = replaceStr.replace(re, this.sourceparam);
                        }
                        this.thankYouTemplateRaw = replaceStr;
                        this.resourcesHtml = '';
                        this.applyThankYouTemplate();
                    } else {
                        this.thankYouTemplateRaw = '';
                        this.resourcesHtml = '';
                    }
                    this.circleId = this.sourceparam;
                    if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.memberRole) {
                        this.memberRole = this.community.content.configureFields.memberRole;
                        if (this.memberRole.value) {
                            this.dynamicFields.memberRole = '';
                            this.memberRole.memberValue = this.memberRole.value.split(",");
                        }
                    }
                    if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.college2) {
                        this.college2 = this.community.content.configureFields.college2;
                        if (this.college2.value) {
                            this.dynamicFields.college2 = '';
                            this.college2.memberValue = this.college2.value.split(",");
                        }
                    }
                    if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.major) {
                        this.major = this.community.content.configureFields.major;
                        if (this.major.value) {
                            this.$set(this.dynamicFields, 'major', []);
                            this.major.memberValue = this.major.value.split(",");
                        }
                    }
                    if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.classYear2) {
                        this.classYear2 = this.community.content.configureFields.classYear2;
                        if (this.classYear2.value) {
                            this.dynamicFields.year2 = '';
                            this.classYear2.memberValue = this.classYear2.value.split(",");
                        }
                    }
                    if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.adviceArea) {
                        this.adviceArea = this.community.content.configureFields.adviceArea;
                        if (this.adviceArea.value) {
                            this.dynamicFields.adviceArea = '';
                            this.adviceArea.memberValue = this.adviceArea.value.split(",");
                        }
                    }

                    if (this.community.content && this.community.content.memberThankYou) {
                        this.memberThankYou = this.community.content.memberThankYou;
                    }
                    if (this.community.content && this.community.content.requestForm) {
                        this.requestForm.subjectLine = this.community.content.requestForm.subjectLine && this.community.content.requestForm.subjectLine.trim() == '' ? 'Short summary ...' : (this.community.content.requestForm.subjectLine ? this.community.content.requestForm.subjectLine.trim() : 'Short summary ...');
                        this.requestForm.question = this.community.content.requestForm.question && this.community.content.requestForm.question.trim() == '' ? "I have a question about ..." : (this.community.content.requestForm.question ? this.community.content.requestForm.question.trim() : "I have a question about ...");
                        this.placeholder.questionPlaceholder = this.requestForm.question;
                    }

                    this.submitBtn.colorBackd = customSettings.primaryBtnBgColor;
                    this.submitBtn.color = customSettings.primaryTxtColor;
                    this.editBtn.colorBackd = customSettings.secondaryBtnBgColor;
                    this.editBtn.color = customSettings.secondaryTxtColor;

                if (community.data.content && community.data.content.configureFields) {
                    this.configureFields = community.data.content.configureFields;
                }
                if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.referrer && this.community.content.configureFields.referrer.labelName) {
                    this.configureFields.referrer.labelName = this.configureFields.referrer.labelName.replace('{{community.name}}', community.data.name);
                }
                if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.referrer2 && this.community.content.configureFields.referrer2.labelName) {
                    this.configureFields.referrer2.labelName = this.configureFields.referrer2.labelName.replace('{{community.name}}', community.data.name);
                    this.referrer2 = this.community.content.configureFields.referrer2;
                        if (this.referrer2.value) {
                            this.dynamicFields.referrer2 = '';
                            this.referrer2.memberValue = this.referrer2.value.split(",");
                        }
                }
                this.logoURL = getLogoURL(customSettings);
                this.footerLogoURL = getFooterURL(customSettings);
                let re = new RegExp(`\\{\\{\\s?community.email\\s?\\}\\}`, 'gi');
                this.finalInvalidMemberMessage = this.community.content && this.community.content.invalidMemberMessage ? this.community.content.invalidMemberMessage.replace(re, (this.community.sender && this.community.sender.address) ? this.community.sender.address : process.env.DEFAULT_EMAIL) : '';

                }),
                this.api.get(`configuration/customizations/interests?community=${this.community_id}&circle=${this.sourceparam}`).then(interests => {
                    this.referenceInterest = interests.data.values;
                })

            ]);
            await this.$helpers.redirectWhenResponseIsSlow(fetchDataPromise, startTime);
            this.isShow = 1;
            this.scrollAfterSkeleton();
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    // instead of router.replace, just flipping the flag
                    this.showNotFound = true
                    return
                }
                if (error.message === 'Timeout occurred') {
                    window.open(process.env.APP_REDIRECT_URL, '_self');
                } else {
                    console.log("Error while fetching the data", error);
                }
            }
              this.$validator.errors.clear();
              this.$validator.reset();
              setTimeout(() => {
                this.addEventListenersToFormFields();
              }, 1000);
        },
        scrollAfterSkeleton: async function() {
            const duration = 500;
            const start = window.scrollY;
            const startTime = performance.now();
            const easeInOutQuad = (t, b, c, d) => {
              t /= d / 2;
              if (t < 1) return c / 2 * t * t + b;
              t--;
              return -c / 2 * (t * (t - 2) - 1) + b;
            };
            const animateScroll = (timestamp) => {
              const currentTime = timestamp - startTime;
              window.scrollTo(0, easeInOutQuad(currentTime, start, -start, duration));
              if (currentTime < duration) {
                requestAnimationFrame(animateScroll);
              } else {
                window.scrollTo(0, 0);
              }
            };
            requestAnimationFrame(animateScroll);
        },
        toggleQuestionVersion() {
            const temp = this.gaiaFormattedAnswer;
            this.gaiaFormattedAnswer = this.lastAnswer || this.requestText;
            this.gaiaAnswer = this.gaiaFormattedAnswer;
            this.lastAnswer = temp;
            this.ask.text = this.sanitizeInput(this.gaiaFormattedAnswer);
            this.isUndo = !this.isUndo;
        },
        toggleEdit() {
            if (this.isEditing) {
                // Validate before saving
                const trimmedText = (this.gaiaAnswer || '').trim();
                const textLength = trimmedText.length;

                if (textLength === 0 || textLength < 200) {
                    // Show error message
                    this.$toast.error('Please expand on what you need help with (minimum 200 characters).');
                    return; // Don't toggle, stay in edit mode
                }

                // If validation passes, save the changes
                this.gaiaFormattedAnswer = saveGaiaAnswer(this.gaiaAnswer);
                this.ask.text = this.sanitizeInput(this.gaiaAnswer);
                this.isEditing = false;
            } else {
                // Switch to edit mode
                this.gaiaAnswer = this.gaiaFormattedAnswer.replace(/<br\s*\/?>/gi, '\n');
                this.isEditing = true;
            }
        },
        viewSecondPage: async function(scope) {
            if (this.community.settings.siteStatus == "Inactive") {
                this.$toast.error('We are no longer accept requests.');
                return null;
            }
            this.isSubjectRequired = false;
            if (!this.ask.subject) {
                this.isSubjectRequired = true;
            }
            this.autoFocus = true;
            this.$validator.validateAll(scope).then(async result => {
                if (result) {
                    window.scrollTo(0, 0);
                    this.isFirstPage = false;
                    this.isSecondPage = false;
                    this.isThirdPage = true;
                    this.isFourthPage = false;
                } else {
                  this.handleErrorMessages();
                }
            });
        },
        goToPage: async function(pageNumber, scrollPosition = 0) {
        window.scrollTo(0, scrollPosition);
        this.isFirstPage = pageNumber === 1;
        this.isSecondPage = pageNumber === 2;
        this.isThirdPage = pageNumber === 3;
        this.isFourthPage = pageNumber === 4;
        this.isSubjectRequired = false;
    },
    goToFirst: async function() {
        this.focusHeading("requestHelpHeader");
        await this.goToPage(1);
    },
    goToThird: async function() {
        await this.goToPage(3, 3);
        this.focusHeading("interests-header")
    },
    askAnotherQuestion() {
        // Reset form state
        this.isBeforeRequest = true;
        this.showSuccessMessage = false;
        this.showErrorMessage = false;
        this.isLoadingResources = false;
        this.showFormFlag = true;
        this.createdAskId = '';
        this.pendingResourceClicks = {};

        // Clear form data
        this.ask = {};
        this.dynamicFields = {};

        // Reset validation
        this.$validator.reset();

        // Navigate to first page and focus
        this.goToFirst();
    },
    goToFourth: async function (scope) {
    this.loading = true;
    this.tempRequestStore(true);
    this.athenaEnabledQC ? this.focusHeading("athenaQuestion-header") : this.focusHeading("closeup-header");

    try {
        const result = await this.$validator.validateAll(scope);
        if (result) {
            this.goToPage(4, 3); // Helper for page navigation
            this.requestText = this.ask.text;
            if (this.athenaEnabledQC) {
                this.gaiaAnswer = await getGaiaQuestion(
                    this.api,
                    this.ask.dynamicFields,
                    this.community,
                    this.channelType,
                    this.selectedInterestList,
                    this.ask
                );
                this.ask.text = this.gaiaAnswer;
                this.gaiaFormattedAnswer = this.gaiaAnswer.replace(/\n/g, '<br>');
            } else if (this.questionCoachEnabled && !this.coachSessionStarted) {
                    try {
                    // Start a new coaching session
                    const { data } = await this.api.post('coach/start-session', {
                        initial_draft: this.ask.text,
                        user_id: "123" //TODO: Replace with users ID
                    }, { timeout: GAIA_TIMEOUT_MS });

                    // Extract evaluation data
                    const guidanceText = data.evaluation.guidance_text || "No guidance available.";
                    const strengths = data.evaluation.strengths || [];
                    const improvements = data.evaluation.improvements || [];
                    const askQualityScore = data.evaluation.ask_quality_score || 0;
                    const checklist = data.evaluation.checklist || null;

                    // Format feedback
                       this.coachFeedback = {
                        guidance: guidanceText,
                        strengths: strengths,
                        improvements: improvements
                        };
                        this.questionCoachScore = askQualityScore;
                        this.coachSessionID = data.session_id || null;
                        this.coachSessionStarted = true;
                        this.coachChecklist = checklist;
                        this.coachUserInfo = this.questionCoachScore >= 8.5 ? this.coachFeedback.strengths : this.coachFeedback.improvements;

                } catch (error) {
                    console.error("Error starting coach session:", error);
                    this.coachFeedback = "There was an issue generating feedback. Please try again.";
                    this.questionCoachScore = 0;
                    this.coachSessionID = null;
            }
        } else {
            console.error("Error generating a coaching response: ", error);
            return null;
        }
        }
    } catch (err) {
        console.error(err);
    } finally {
        this.loading = false;

        // Generate tags using Gemini API
        /*let generatedTags = ['general'];
        const tagsResponse = await this.api.post('asks/generate-tags-preview', {
            subject: this.ask.subject || 'Quick Connect',
            text: this.ask.text
        }).catch(error => {
            console.error("[FRONTEND] Error generando tags preview:", error);
            return null;
        });

        if (tagsResponse && tagsResponse.data && tagsResponse.data.success && tagsResponse.data.tags) {
            generatedTags = tagsResponse.data.tags;
        } else {
            console.warn("[FRONTEND] No tags generated, using fallback: ['general']");
        }*/

        const resourceMessage = this.requestText || this.ask.text || '';
        // Only fills the resources block on the thank-you page, so a slow or
        // failed match must not hold up the form.
        let matchResources = null;
        try {
            matchResources = await this.api.post(
                `communities/${this.community_id}/match-resources`,
                {
                    email: this.ask.email,
                    memberRole: this.dynamicFields.memberRole || null,
                    circle: this.sourceparam || '',
                    message: resourceMessage,
                    maxResources: 3
                },
                { timeout: GAIA_TIMEOUT_MS }
            );
        } catch (e) {
            console.error('Resource matching failed; continuing without resources:', e);
        }


        // Build the same HTML fragment used by fetchResources so preview and final view match visually
        try {
            this.matchedResources = (matchResources && matchResources.data) || [];
            const matches = (matchResources && matchResources.data) || [];
            const resourcesHtml = this.renderResourcesHtml(matches);
            if (!resourcesHtml) {
                console.warn('No matched resources returned from matcher.');
            }

            this.resourcesHtml = resourcesHtml;
            this.applyThankYouTemplate(resourcesHtml);
        } catch (e) {
                    console.error('Error rendering matcher resources into thank-you template', e);
        }
    }
},
        async questionCoach() {
            this.questionCoachScore = 0;
            try {
                const { data } = await this.api.post('coach/coach-draft', {
                    question: this.ask.text,
                    session_id: this.coachSessionID
                }, { timeout: GAIA_TIMEOUT_MS });

                // Extract evaluation data
                const guidanceText = data.revised_evaluation.guidance_text || "No guidance available.";
                const strengths = data.revised_evaluation.strengths || [];
                const improvements = data.revised_evaluation.improvements || [];
                const askQualityScore = data.revised_evaluation.ask_quality_score || 0;
                const checklist = data.revised_evaluation.checklist || null;

                // Format feedback
                this.coachFeedback = {
                    guidance: guidanceText,
                    strengths: strengths,
                    improvements: improvements
                };
                this.questionCoachScore = askQualityScore;
                this.coachChecklist = checklist;
                this.coachUserInfo = this.questionCoachScore >= 8.5 ? this.coachFeedback.strengths : this.coachFeedback.improvements;

            } catch (error) {
                console.error("Error getting coaching feedback:", error);

                // Optional fallbacks to avoid stale or undefined state
                this.coachFeedback = "There was an issue generating feedback. Please try again.";
                this.questionCoachScore = 0;
            }
        },
        tempRequestStore: async function(defaultReason = false) {
            this.normalizeArrayFields(); // Ensure arrays are normalized before storing
            this.ask.subject = 'Quick Connect';
            this.ask.community = this.community._id;
            this.ask.dynamicFields = this.dynamicFields;
            this.ask.first = this.dynamicFields.first;
            this.ask.last = this.dynamicFields.last;
            this.ask.channelType = this.channelType;
            this.ask.formType = 'QC';
            this.ask.sourceparam = this.sourceparam;
            this.ask.reason = defaultReason;
            this.ask.actionPage = this.actionPage;
            this.ask.prompt = this.ask.text;
            delete this.ask.recipients;
            await this.api.post(`asks/${this.community_id}/create-temp-request/`, this.ask).then(response => {});
        },
        deleteTempRequest: async function() {
            await this.api.post(`asks/${this.community_id}/delete-temp-request/`, this.ask).then(response => {});
        },
        save: async function(scope) {
            // Prevent double submission
            if (this.isSubmitting) {
                console.log("Form submission already in progress");
                return;
            }

            this.isSubmitting = true;

            //console.log("Save ran");
            if (this.community.settings.siteStatus == "Inactive") {
                this.$toast.error('We are no longer accept requests.');
                this.isSubmitting = false;
                return null;
            }
            try {
                // Normalize array fields before processing (fix for major field)
                if (this.dynamicFields && Array.isArray(this.dynamicFields.major)) {
                    this.dynamicFields.major = [...new Set(this.dynamicFields.major
                        .filter(item => item && typeof item === 'string' && item.trim().length > 0)
                        .map(item => item.trim())
                    )].sort((a, b) => a.localeCompare(b));
                }

                this.ask.text = this.sanitizeInput(this.ask.text);
                this.ask.subject = this.sanitizeInput('Quick Connect');
            if (this.dynamicFields) {
               Object.keys(this.dynamicFields).forEach(key => {
                  const value = this.dynamicFields[key];
                  const selectElement = document.querySelector(`select[name="${key}"]`);
                  if (Array.isArray(value)) {
                    this.dynamicFields[key] = value
                    .map(v => typeof v === 'string' ? v.trim() : v)
                    .filter(v => v && v !== '');
                  } else if (selectElement) {
                    const options = Array.from(selectElement.options)
                    .map(option => option.value)
                    .filter(v => v !== '');
                  if (value && !options.includes(value)) {
                     this.dynamicFields[key] = '';
                  }
                  } else if (typeof value === 'string') {
                     this.dynamicFields[key] = this.sanitizeInput(value);
                  }
                });
              }

                await this.api.get(`communities/${this.community_id}/administrators`).then(administrators => {
                    this.administrators = administrators.data;
                    if (administrators && administrators.data) {
                        this.administrators.map(singleAdmin => {
                            this.newAdmin.push(singleAdmin.member);
                        });
                    }
                });

                this.ask.recipients = this.newAdmin;
                this.ask.dynamicFields = this.dynamicFields;
                this.ask.first = this.dynamicFields.first;
                this.ask.last = this.dynamicFields.last;
                this.ask.email = this.dynamicFields.email;
                this.ask.channelType = this.channelType;
                this.ask.formType = 'QC';
                this.ask.sourceparam = this.sourceparam;
                this.ask.actionPage = this.actionPage;
                this.ask.prompt = this.ask.text;
                // The API writes the Gaia subject line in the background after the
                // ask is created, so submitting doesn't wait on it.
                this.ask.subject = "Quick Connect";
                this.ask.source = {
                    origin: "request page",
                    sourceID: `timestamp:${Date.now()}`,
                    userID: "Web user"
                };
                if (this.selectedInterestList && this.selectedInterestList.length > 0) {
                    this.dynamicFields.interests = this.selectedInterestList;
                }

                if (!this.unsubscribe && !this.spamEmail && !this.invalidMember) {
                    if (this.memberThankYou) {
                        this.showFormFlag = false;
                        window.open(this.memberThankYou, '_self');
                    } else {
                        this.showFormFlag = false;
                        if (this.configureFields.interest && this.configureFields.interest.include == true) {
                            this.showFormFlag = true;
                            this.isFirstPage = false;
                            this.isSecondPage = false;
                            this.isThirdPage = false;

                        this.$nextTick(() => {
                            const checkboxRef = this.$refs.checkboxMainRef;
                            Object.keys(checkboxRef).forEach(function(key) {
                                const currentElement = checkboxRef[key];
                                if (currentElement.querySelector('.md-checked')) {
                                    const checkboxInput = currentElement.querySelector('input[type=checkbox]');
                                    if (checkboxInput) {
                                        checkboxInput.checked = true;
                                        checkboxInput.dispatchEvent(new Event('change'));
                                    }
                                }
                            });
                        });

                    } else {
                        document.title = this.community.name + " | Thank You";
                        this.isBeforeRequest = false;
                    }
                }
                if (this.showFormFlag == false) {
                    this.disabledBtn = 1;
                    window.scrollTo(0, 0);
                }
                const hasPrefetchedResources = /<a\s+href=/i.test(this.resourcesHtml || '');
                if (hasPrefetchedResources && this.thankYouTemplateRaw) {
                    this.applyThankYouTemplate(this.resourcesHtml);
                }
                this.isLoadingResources = true;
                this.isBeforeRequest = false;
                this.showSuccessMessage = false;
                this.showErrorMessage = false;
                this.errorMessage = '';
                // Keep already-rendered resources visible while create-ask is pending.
                const hasRenderedResources = /<a\s+href=/i.test(this.resourcesHtml || '');
                if (!hasRenderedResources) {
                    this.prepareThankYouForLoading();
                }
                this.focusHeading("whatsnext-header");
                this.ask.text = this.ask.text.replace(/<br\s*\/?>/gi, '\n');
                try {
                    this.ask.coachingSessionId = this.coachSessionID;
                    this.ask.matchedResources = this.matchedResources;
                    const askResponse = await this.api.post(`communities/${this.community_id}/create-ask/`, this.ask);
                    const ask = askResponse;
                    this.callTrackEvent(ask);
                    if (ask.data.unsubscribe) {
                        this.isLoadingResources = false;
                        this.loading = false;
                        this.resourcesHtml = '';
                        if (this.thankYouTemplateRaw) {
                            this.applyThankYouTemplate('');
                        }
                        this.$toast.error('Your email address has been unsubscribed.');
                        this.focusHeading("whatsnext-header");
                    } else if (ask.data.spamEmail) {
                        this.isLoadingResources = false;
                        this.loading = false;
                        this.resourcesHtml = '';
                        if (this.thankYouTemplateRaw) {
                            this.applyThankYouTemplate('');
                        }
                        this.$toast.error('Your email address has been blocked.');
                        this.focusHeading("whatsnext-header");
                    } else if (ask.data.invalidMember || ask.data.inactiveMember) {
                        this.isLoadingResources = false;
                        this.loading = false;
                        this.resourcesHtml = '';
                        if (this.thankYouTemplateRaw) {
                            this.applyThankYouTemplate('');
                        }
                        this.tempRequestStore(true);
                        this.focusHeading("whatsnext-header");
                    } else {
                        if (this.configureFields.interest && this.configureFields.interest.include == true && ask.data.askCreator) {
                            this.ask = ask.data;
                            this.askCreator = ask.data.askCreator; // Timing when filled is slow, if Submit button in affinities is clicked before filling it causes error
                            this.disabledBtn = 0; // Added this here and a :disabled in submit button to manage button
                        } else {
                            document.title = this.community.name + " | Thank You";
                        }
                        try {
                            const askId = ask && ask.data ? ask.data._id : '';
                            if (askId && Array.isArray(this.matchedResources) && this.matchedResources.length) {
                                this.createdAskId = askId;
                                const trackedResourcesHtml = this.renderResourcesHtml(this.matchedResources, askId);
                                if (trackedResourcesHtml) {
                                    this.resourcesHtml = trackedResourcesHtml;
                                    this.applyThankYouTemplate(trackedResourcesHtml);
                                }
                            }
                            if (askId) {
                                this.flushPendingResourceClicks(askId);
                            }
                        } catch (error) {
                            console.error("Error applying tracked resource links:", error);
                        } finally {
                            this.isLoadingResources = false;
                            this.loading = false;
                            this.isFirstPage = false;
                            this.isSecondPage = false;
                            this.isThirdPage = false;
                            this.isFourthPage = false;
                            this.isBeforeRequest = false;
                            document.title = 'Thank You';
                            window.scrollTo(0, 0);
                            if (!this.showErrorMessage) {
                                this.showSuccessMessage = true;
                            }
                            this.focusHeading("whatsnext-header");
                        }
                    }
                } catch (error) {
                    console.error("Error creating ask:", error);
                    this.isLoadingResources = false;
                    this.showErrorMessage = true;
                    this.errorMessage = (error && error.response && error.response.data && error.response.data.error)
                        ? error.response.data.error
                        : 'Something went wrong while submitting your request. Please try again.';
                    this.resourcesHtml = '';
                    if (this.thankYouTemplateRaw) {
                        this.applyThankYouTemplate('');
                    }
                    this.focusHeading("whatsnext-header");
                }
            } else {
                if (this.unsubscribe) {
                    this.$toast.error('Your email address has been unsubscribed.');
                } else if (this.spamEmail) {
                    this.$toast.error('Your email address has been blocked.');
                } else if (this.invalidMember) {
                    this.disabledBtn = 1;
                    this.showFormFlag = false; //use this flag to hide show form
                    this.isBeforeRequest = false;
                    this.invalidMember = true;
                    this.tempRequestStore(true);
                }
            }
        } catch (error) {
            console.error("Error in save operation ", error);
        } finally {
            // Reset submission flag after completion or error (with delay to prevent rapid re-submission)
            setTimeout(() => {
                this.isSubmitting = false;
            }, 2000);
        }
        },
        hasThankYouPlaceholder() {
            return typeof this.thankYouTemplateRaw === 'string' && /\{\{\s?ask\.resources\s?\}\}/i.test(this.thankYouTemplateRaw);
        },
        applyThankYouTemplate(customMarkup) {
            if (!this.community || !this.community.content) {
                return;
            }

            if (!this.thankYouTemplateRaw) {
                if (this.community.content.requestPageThankYou) {
                    this.community.content.requestPageThankYou = '';
                }
                return;
            }

            const template = this.thankYouTemplateRaw;
            const placeholderCheck = /\{\{\s?ask\.resources\s?\}\}/i;
            const hasPlaceholder = placeholderCheck.test(template);
            const replacement = typeof customMarkup === 'string' ? customMarkup : (this.resourcesHtml || '');

            let renderedTemplate = template;
            if (hasPlaceholder) {
                renderedTemplate = template.replace(/\{\{\s?ask\.resources\s?\}\}/gi, replacement);
            } else if (replacement && /<a\s+href=/i.test(replacement)) {
                const hasResourcesAlready = /class=["']pt-auto-resources-block["']/i.test(template);
                renderedTemplate = hasResourcesAlready ? template : `${template}${replacement}`;
            }

            this.community.content.requestPageThankYou = this.sanitizeListHTML(renderedTemplate);
        },
        prepareThankYouForLoading() {
            if (!this.hasThankYouPlaceholder()) {
                return;
            }

            this.resourcesHtml = this.loadingResourcesHtml;
            this.applyThankYouTemplate();
        },
        callTrackEvent(ask) {
            this.$gtm.enable(true)
            this.$gtm.trackEvent({
                'RequestID': ask.data._id,
                'RequestSource': 'Web',
                'RequestReceived': this.$moment(ask.data.createdAt).tz("America/New_York").format('YYYYMMDD'),
                'Community': this.community.name,
                'event': 'RequestSubmitted'
            });
        },
        buildResourceTrackingUrl(resourceId, url, askId) {
            const safeUrl = this.sanitizeUrl(url || '');
            if (!askId || !resourceId || !safeUrl) {
                return safeUrl || '#';
            }

            const apiBase = (process.env.API_BASEURL || '').replace(/\/$/, '');
            const redirect = encodeURIComponent(safeUrl);
            return `${apiBase}/dashboard/resource/${encodeURIComponent(askId)}/${encodeURIComponent(resourceId)}/track-click?location=request_page&redirect=${redirect}`;
        },
        normalizeMatchedResource(match) {
            const resourceObj = match && match.resourceId && typeof match.resourceId === 'object' ? match.resourceId : null;
            const resourceId = (resourceObj && (resourceObj._id || resourceObj.id)) || (match && (match.resourceId || match._id || match.id)) || '';
            const url = this.sanitizeUrl((match && (match.url || (resourceObj && resourceObj.url))) || '');
            const name = (resourceObj && resourceObj.name) || (match && match.name) || url || '';
            const desc = this.sanitizeResourceDescription((match && (match.description || (resourceObj && resourceObj.description))) || '');

            return {
                resourceId: resourceId ? String(resourceId) : '',
                url,
                name,
                desc
            };
        },
        renderResourcesHtml(matches, askId = '') {
            if (!Array.isArray(matches) || !matches.length) {
                return '';
            }

            const communityColor = (this.community && this.community.customSettings && this.community.customSettings.primaryBtnBgColor) || '#000';
            let resourcesHtml = '<div class="pt-auto-resources-block"><div style="padding-top: 20px; padding-bottom: 20px;">Based on your question, here are some resources you can access right away: </div><ul style="list-style-type: none; padding: 0; margin: 0;">';

            matches.forEach(match => {
                const { resourceId, url, name, desc } = this.normalizeMatchedResource(match);
                if (!name && !url) return;

                const href = this.buildResourceTrackingUrl(resourceId, url, askId);
                const safeName = this.sanitizeHtmlTemplate(name);

                resourcesHtml += `\n<li style="margin-bottom: 15px; font-size: 16px; font-weight: 300; line-height: 22px;">`;
                resourcesHtml += `\n<a href="${href || '#'}" data-resource-id="${resourceId}" data-resource-url="${url}" target="_blank" rel="noopener noreferrer" style="color: ${communityColor}; font-weight: bold; text-decoration: underline;" aria-label="Learn more about ${safeName}">${safeName}</a>`;
                resourcesHtml += `\n<span style="font-size:20px; font-weight: 300; margin-left: 5px;">${desc ? '- ' + desc : ''}</span>`;
                resourcesHtml += `\n</li>`;
            });

            resourcesHtml += '\n</ul></div>';
            return resourcesHtml;
        },
        handleThankYouResourceClick(event) {
            if (!event || !event.target || typeof event.target.closest !== 'function') {
                return;
            }

            const anchor = event.target.closest('a[data-resource-id]');
            if (!anchor) {
                return;
            }

            const resourceId = anchor.getAttribute('data-resource-id') || '';
            const resourceUrl = this.sanitizeUrl(anchor.getAttribute('data-resource-url') || '');
            if (!resourceId || !resourceUrl) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            window.open(resourceUrl, '_blank', 'noopener');

            const askId = this.createdAskId || '';
            if (askId) {
                this.api.get(
                    `dashboard/resource/${encodeURIComponent(askId)}/${encodeURIComponent(resourceId)}/track-click`,
                    {
                        location: 'request_page',
                        redirect: resourceUrl,
                        skipRedirect: true
                    }
                ).catch((error) => {
                    console.error('Error tracking resource click:', error);
                });
            } else {
                if (!this.pendingResourceClicks[resourceId]) {
                    this.$set(this.pendingResourceClicks, resourceId, { count: 0, url: resourceUrl });
                }
                this.pendingResourceClicks[resourceId].count += 1;
            }
        },
        flushPendingResourceClicks(askId) {
            if (!askId || !this.pendingResourceClicks || !Object.keys(this.pendingResourceClicks).length) {
                return;
            }

            Object.keys(this.pendingResourceClicks).forEach(resourceId => {
                const pending = this.pendingResourceClicks[resourceId];
                const count = pending && pending.count ? pending.count : 0;
                const url = this.sanitizeUrl((pending && pending.url) || '');
                if (!count || !url) {
                    return;
                }

                for (let i = 0; i < count; i++) {
                    this.api.get(
                        `dashboard/resource/${encodeURIComponent(askId)}/${encodeURIComponent(resourceId)}/track-click`,
                        {
                            location: 'request_page_loader',
                            redirect: url,
                            skipRedirect: true
                        }
                    ).catch((error) => {
                        console.error('Error syncing pending resource click:', error);
                    });
                }
            });

            this.pendingResourceClicks = {};
        },
        sanitizeInput(input) {

            return sanitizeInput(input);

        },

        sanitizeUrl(url) {

            return sanitizeUrl(url);

        },

        sanitizeHtmlTemplate(template) {

            return sanitizeHtmlTemplate(template);

        },

        sanitizeResourceDescription(description) {

            return sanitizeResourceDescription(description);

        },

        sanitizeListHTML(html) {
            if (!html) return html;

            // Create a temporary div to parse the HTML
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            // Find all ul and ol elements
            const lists = tempDiv.querySelectorAll('ul, ol');

            lists.forEach(list => {
                // Get all direct children that are not li, script, or template
                const invalidChildren = Array.from(list.children).filter(child =>
                    !['LI', 'SCRIPT', 'TEMPLATE'].includes(child.tagName)
                );

                // Wrap invalid children in li elements
                invalidChildren.forEach(child => {
                    const li = document.createElement('li');
                    list.insertBefore(li, child);
                    li.appendChild(child);
                });
            });

            return tempDiv.innerHTML;
        },

        checkAndValidate1(field) {
            var validationRules = ''; // Default to empty string instead of undefined
            if (this.configureFields && field === 'college') {
                validationRules = this.configureFields.college && this.configureFields.college.require && this.configureFields.college.require === true ? 'required' : '';
            return validationRules;
            } else if (this.configureFields && field === 'college2') {
                validationRules = this.configureFields.college2 && this.configureFields.college2.require && this.configureFields.college2.require === true ? 'required' : '';
            return validationRules;
            } else if (this.configureFields && field === 'year') {
                validationRules = this.configureFields.classYear && this.configureFields.classYear.require && this.configureFields.classYear.require === true ? 'required' : '';
            return validationRules;
           } else if (this.configureFields && field === 'major') {
                validationRules = this.configureFields.major && this.configureFields.major.require && this.configureFields.major.require === true ? 'required' : '';
            return validationRules;
            } else if (this.configureFields && field === 'year2') {
                validationRules = this.configureFields.classYear2 && this.configureFields.classYear2.require && this.configureFields.classYear2.require === true ? 'required' : '';
            return validationRules;
            } else if (this.configureFields && field === 'role') {
            validationRules = this.configureFields.title && this.configureFields.title.require && this.configureFields.title.require === true ? 'required' : '';
            return validationRules;
            } else if (this.configureFields && field === 'organization') {
            validationRules = this.configureFields.organization && this.configureFields.organization.require && this.configureFields.organization.require === true ? 'required' : '';
            return validationRules;
            } else if (this.configureFields && field === 'studentId') {
            validationRules = this.configureFields.studentId && this.configureFields.studentId.require && this.configureFields.studentId.require === true ? 'required' : '';
            return validationRules;
            } else if (this.configureFields && field === 'dueDate') {
            validationRules = this.configureFields.dueDate && this.configureFields.dueDate.require && this.configureFields.dueDate.require === true ? 'required' : '';
            return validationRules;
            } else if (this.configureFields && field === 'linkedInProfile') {
            validationRules = this.configureFields.linkedInProfile && this.configureFields.linkedInProfile.require && this.configureFields.linkedInProfile.require === true ? 'required' : '';
            return validationRules;
            } else if (this.configureFields && field === 'phoneNumber') {
            validationRules = this.configureFields.phoneNumber && this.configureFields.phoneNumber.require && this.configureFields.phoneNumber.require === true ? 'required' : '';
            return validationRules;
            } else if (this.configureFields && field === 'referrer') {
            validationRules = this.configureFields.referrer && this.configureFields.referrer.require && this.configureFields.referrer.require === true ? 'required' : '';
            return validationRules;
            } else if (this.configureFields && field === 'referrer2') {
                validationRules = this.configureFields.referrer2 && this.configureFields.referrer2.require && this.configureFields.referrer2.require === true ? 'required' : '';
                return validationRules;
            } else if (this.configureFields && field === 'disclaimer') {
            validationRules = this.configureFields.disclaimer && this.configureFields.disclaimer.require && this.configureFields.disclaimer.require === true ? 'required' : '';
            return validationRules;
            } else if (this.configureFields && field === 'memberRole') {
            validationRules = this.configureFields.memberRole && this.configureFields.memberRole.require && this.configureFields.memberRole.require === true ? 'required' : '';
            return validationRules;
            } else if (this.configureFields && field === 'adviceArea') {
            validationRules = this.configureFields.adviceArea && this.configureFields.adviceArea.require && this.configureFields.adviceArea.require === true ? 'required' : '';
            return validationRules;
            }
            return validationRules; // Always return a value, default to empty string
        },
        updateDisclaimer: function() {
            if (this.dynamicFields.disclaimer === false && this.configureFields.disclaimer.require && this.configureFields.disclaimer.require === true) {
                this.dynamicFields.disclaimer = undefined;
            }
        },
        updateProfile: async function() {
            // this.disabledBtn = 1;
            console.log("updateProfile Ran");
            if (!this.askCreator || !this.askCreator._id) {
                console.warn("updateProfile skipped: askCreator is not populated yet.");
                return;
            }
            var memberUpdateData = {
                requestId: this.ask._id,
                giveId: null,
                communityId: this.community._id,
                community: this.community.name,
                circleId: this.sourceparam,
                memberId: this.askCreator._id,
                propertyId: this.askCreator.propertyId,
                name: this.askCreator.displayName,
                email: this.askCreator.emails ? this.askCreator.emails.toString().toLowerCase() : '',
                memberObj: this.askCreator,
                callFrom: 'create-request-page',
                isAsker: true
            };
            const existingInterests = this.askCreator.interests || [];
            const newInterests = this.selectedInterestList || [];
            memberUpdateData.memberObj.interests = [...new Set([...existingInterests, ...newInterests])];
            this.isThirdPage = false;
            this.isBeforeRequest = false;
            document.title = this.community.name + " | Thank You";
            window.scrollTo(0, 0);
            await this.api.post(`members/profile-update`, memberUpdateData).then(response => {
                this.askCreator = this.memberObj;
            });
            // this.disabledBtn = 0;
        },
        checkMemberStatus: function() {
            this.ask.email = this.dynamicFields.email
            this.api.post(`communities/${this.community_id}/get-member-details/`, this.ask)
                .then(async ask => {
                    this.unsubscribe = this.spamEmail = this.invalidMember = false;
                    if (ask.data.unsubscribe) {
                        this.unsubscribe = true;
                    }
                    if (ask.data.spamEmail) {
                        this.spamEmail = true;
                    }
                    if (ask.data.invalidMember || ask.data.inactiveMember) {
                        this.invalidMember = true;
                    }
                    if (!this.unsubscribe && !this.spamEmail && !this.invalidMember) {
                        // if (ask.data._id) {
                        //     this.memberInterestList = new Map(ask.data.interests.map(s => [s.toLowerCase(), s]));
                        //     this.memberInterestList = [...this.memberInterestList.values()];
                        // } else {
                        //     this.memberInterestList = []
                        // }
                        var memberRefrenceInterest = this.referenceInterest;
                        var mergedInterest = new Map(memberRefrenceInterest.map(s => [s.toLowerCase(), s]));
                        mergedInterest = [...mergedInterest.values()];
                        const n = process.env.RANDOM_INTEREST_COUNT;
                        var shuffled = mergedInterest.sort(function() { return 0.5 - Math.random(); });
                        this.randomInterest = shuffled.slice(0, n);
                        if (ask.data.school1) {
                            this.school = ask.data.school1;
                        }
                        if (ask.data.year1) {
                            this.year = ask.data.year1;
                        }
                    }
                })
        },
        countdown: function() {
            this.textCount = this.ask.text && this.ask.text.length ? this.ask.text.length : 0;
            this.textCount < 200 || this.textCount === 0 ? (this.underMinCount = true) : (this.underMinCount = false);
        },
        updateAriaChecked: function(randomInterestItem) {
            const checkboxRef = this.$refs.checkboxMainRef;

            Object.keys(checkboxRef).forEach(function(key) {
                const currentElement = checkboxRef[key];
                const checkboxInput = currentElement.querySelector('input[type="checkbox"]');

                if (checkboxInput.value == randomInterestItem) {
                    // Currently it's checked. Need to make it unchecked
                    let setCheckbox = true;
                    if (currentElement.querySelector('.md-checked')) {
                        setCheckbox = false
                    }
                    checkboxInput.checked = setCheckbox;
                }
            });
        },
        handleQuestionFocusEvent: function() {
            this.hideQuestionPlaceholder();
        },
        handleQuestionBlurEvent: function() {
            if (this.ask.text == undefined || this.ask.text.length == 0) {
                this.requestForm.question = this.placeholder.questionPlaceholder;
                this.placeholderStyle.pointerEvents = "visible";
            }
        },
        hideQuestionPlaceholder: function() {
            this.requestForm.question = "";
            this.placeholderStyle.pointerEvents = "none";
        },
        onMagicWandExampleInserted: function(field) {
            if (field === 'text') {
                this.hideQuestionPlaceholder();
            }
        },
        handlePlaceholderClick: function() {
            this.hideQuestionPlaceholder();
            this.$refs.questionPlaceholderRef.focus();
        },
        updateAndSubmit: async function() {
            this.normalizeArrayFields(); // Ensure arrays are normalized before save
            await this.save(); // `save` will complete first
            await this.updateProfile(); // `updateProfile` is called after `save` finishes
        },
        handleFocusOnQuestionError: function() {
          const textArea = document.getElementById('prompt');
          if (textArea.classList.contains('question-error-present')) {
              this.$refs.questionPlaceholderRef.focus();
          }
        },
        handleErrorMessages: function() {
          const errorElements = document.querySelectorAll('.error');
              if (errorElements.length > 0) {
                  let isFirstErrorFocused = false;
                  for (let errorElement of errorElements) {
                        if (errorElement.style.display !== 'none') {
                          let inputElement = '';
                          if (errorElement.classList.contains('error-message-textarea')) {
                            inputElement = errorElement.parentNode.querySelector('textarea');
                          } else {
                            inputElement = errorElement.previousElementSibling;
                          }
                            while (inputElement) {
                              var message = "";
                                if ((inputElement.tagName === 'INPUT' || inputElement.tagName === 'SELECT' || inputElement.tagName === 'DIV' || inputElement.tagName === 'TEXTAREA') && !isFirstErrorFocused) {
                                    if (inputElement.tagName === 'DIV') {
                                        if (inputElement.parentNode.querySelector('textarea.request-form-error-border')) {
                                          inputElement.parentNode.querySelector('textarea.request-form-error-border').focus();
                                          message = errorElement.innerText;
                                          this.errorMessageAnnouncement(message);
                                            isFirstErrorFocused = true;
                                            break;
                                        }
                                    } else {
                                      inputElement.focus();
                                      message = errorElement.innerText;
                                      this.errorMessageAnnouncement(message);
                                      setTimeout(() => {
                                        this.autoFocus = false;
                                      }, 2000);
                                      isFirstErrorFocused = true;
                                        break;
                                    }
                                }
                                inputElement = inputElement.previousElementSibling;
                            }
                        }
                    }
                }
        },
        errorMessageAnnouncement(message) {
          const liveRegion = document.createElement('div');
          liveRegion.setAttribute('aria-live', 'polite');
          liveRegion.setAttribute('role', 'alert');
          liveRegion.innerText = message;
          document.body.appendChild(liveRegion);
          setTimeout(() => {
            liveRegion.remove();
          }, 1000);
        },
        addEventListenersToFormFields: function() {
          const form = document.querySelectorAll('input, textarea, select');
          form.forEach((element) => {
            element.addEventListener('focus', (event) => {
              if (!this.autoFocus) {
                var formField = event.target;
                var message = '';
                if (formField.tagName === 'INPUT' || formField.tagName === 'SELECT') {
                  message = formField.nextElementSibling.innerText;
                } else if (formField.tagName === 'TEXTAREA' && formField.parentNode.querySelector('.error')) {
                  message = formField.parentNode.querySelector('.error').innerText;
                }
                this.errorMessageAnnouncement(message);
              }
            });
          });
    }

    }
};
</script>

<style>
    .text-container-placeholder {
        position: relative;
        overflow: auto;
    }

    .placeholder-overlay {
        font-family: Roboto !important;
        font-weight: 700 !important;
        font-size: 18px !important;
        line-height: 21px !important;
        color: #000 !important;
        position: absolute;
        word-wrap: break-word;
        overflow: auto;
        top: 60px;
        bottom: 10px;
        left: 15px;
        right: 5px;
        padding-right: 15px;
        /* pointer-events:none; */ /*Make sure the overlay doesn't interfere with user interactions */
        z-index: 10;
        user-select: none;
    }

    .placeholder-overlay.magicwand-enabled {
        top: 40px !important;
    }

    /* Fix color contrast for disabled datepicker days */
    .vdp-datepicker .cell.day.disabled,
    .vdp-datepicker .cell.disabled,
    .vdp-datepicker span.cell.day.disabled {
        color: #6c757d !important; /* Changed from #dddddd to pass 4.5:1 contrast ratio */
    }

    .vdp-datepicker .cell.day.disabled.weekend,
    .vdp-datepicker .cell.disabled.weekend,
    .vdp-datepicker span.cell.day.disabled.weekend {
        color: #6c757d !important; /* Changed from #dddddd to pass 4.5:1 contrast ratio */
    }

    .vdp-datepicker .cell.day.disabled.today,
    .vdp-datepicker .cell.disabled.today,
    .vdp-datepicker span.cell.day.disabled.today {
        color: #6c757d !important; /* Changed from #dddddd to pass 4.5:1 contrast ratio */
    }

    /* More specific selectors for weekend days */
    .vdp-datepicker span.cell.day.disabled.weekend.sat,
    .vdp-datepicker span.cell.day.disabled.weekend.sun {
        color: #6c757d !important; /* Changed from #dddddd to pass 4.5:1 contrast ratio */
    }

    /* Override any existing styles with higher specificity */
    .vdp-datepicker__calendar .cell.day.disabled {
        color: #6c757d !important;
    }

    .vdp-datepicker__calendar span.cell.disabled {
        color: #6c757d !important;
    }

    /* Ensure disabled elements have proper contrast across all states */
    .input-focus.template-input-date-picker .cell.disabled,
    .template-input-date-picker .vdp-datepicker__calendar .cell.disabled {
        color: #6c757d !important;
    }

    /* Enhanced accessibility for datepicker cells */
    .vdp-datepicker .cell:focus {
        outline: 2px solid #007bff !important;
        outline-offset: 1px !important;
        background-color: #e3f2fd !important;
    }

    .vdp-datepicker .cell[data-accessibility-enhanced]:focus {
        box-shadow: 0 0 0 2px #007bff !important;
        z-index: 10;
        position: relative;
    }

    /* Remove native tooltips styling */
    .accessible-datepicker .cell[title] {
        pointer-events: auto;
    }

    /* Improve keyboard navigation indicators */
    .vdp-datepicker .cell[tabindex="0"]:focus-visible {
        outline: 2px solid #007bff;
        outline-offset: 2px;
        background-color: #e3f2fd;
    }

    /* Make md-tooltip visible when the trigger receives keyboard focus (preserve hover styles) */
    /* This targets the md-tooltip sibling that Material adds; it's minimally invasive */
    /* Cover cases where md-tooltip is a descendant or may be rendered via a portal; also use focus-within on container */
    .template-tooltip-span:focus .md-tooltip,
    .template-tooltip-span:focus .md-tooltip.md-direction-right,
    .template-tooltip-span:focus .md-tooltip.md-direction-left,
    .template-tooltip-span:focus .md-tooltip.md-direction-top,
    .template-tooltip-span:focus .md-tooltip.md-direction-bottom,
    .tooltip-container:focus-within .md-tooltip,
    .tooltip-container:focus-within .md-tooltip.md-direction-right,
    .tooltip-container:focus-within .md-tooltip.md-direction-left,
    .tooltip-container:focus-within .md-tooltip.md-direction-top,
    .tooltip-container:focus-within .md-tooltip.md-direction-bottom {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
    }

    /* Keep existing hover behavior intact (no overrides) */

    /* Question Coach Checklist Styles */
    .feedback-checklist {
        list-style: none;
        padding: 0;
        margin: 20px 0 0 0;
    }

    .checklist-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 12px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        transition: all 0.2s ease;
    }

    .checklist-item:last-child {
        border-bottom: none;
    }

    .checkbox-icon {
        flex-shrink: 0;
        margin-top: 2px;
        transition: transform 0.2s ease;
    }

    .checkbox-icon.checked {
        animation: checkPop 0.3s ease;
    }

    @keyframes checkPop {
        0% { transform: scale(1); }
        50% { transform: scale(1.2); }
        100% { transform: scale(1); }
    }

    .checklist-text {
        flex: 1;
        font-family: Roboto Slab !important;
        font-style: normal !important;
        font-weight: 300 !important;
        font-size: 16px !important;
        line-height: 20px !important;
        color: #000000 !important;
    }

    .checklist-text.text-muted {
        color: #6B7280;
        font-family: Roboto Slab !important;
        font-style: normal !important;
        font-weight: 300 !important;
    }

    .checklist-item.checked .checklist-text {
        color: #059669;
    }

    .score-circle {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 8px;
    }

    .score-circle svg {
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
    }

    .feedback-card {
        border-radius: 12px;
        padding: 24px;
        margin-bottom: 24px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        transition: all 0.3s ease;
    }

    .feedback-emoji-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        min-width: 100px;
    }

    .feedback-content {
        flex: 1;
        padding-right: 24px;
        font-family: Roboto Slab !important;
        font-style: normal !important;
        font-weight: 300 !important;
        font-size: 18px !important;
        line-height: 22px !important;
        color: #000000 !important;
    }

    /* Improvements Section Styles */
    .improvements-section {
        margin-top: 24px;
        padding-top: 20px;
        border-top: 1px solid rgba(0, 0, 0, 0.08);
    }

    .improvements-title {
        font-family: Roboto Slab !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 16px !important;
        line-height: 20px !important;
        color: #000000 !important;
        margin-bottom: 16px;
    }

    .improvements-list {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .improvement-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 12px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        font-family: Roboto Slab !important;
        font-style: normal !important;
        font-weight: 300 !important;
        font-size: 16px !important;
        line-height: 20px !important;
        color: #000000 !important;
    }

    .improvement-item:last-child {
        border-bottom: none;
    }

    .improvement-item::before {
        content: "→";
        color: #6B7280;
        font-weight: 600;
        flex-shrink: 0;
        margin-top: 2px;
    }

    .big-emoji {
    font-size: 5rem;
    line-height: 1;
}

.feedback-card {
    display: grid;
    grid-template-columns: 1fr 100px;
    gap: 1.5rem;
    padding: 1.5rem;
    border-radius: 12px;
    align-items: start;
}

.feedback-content {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    font-family: Roboto Slab !important;
    font-style: normal !important;
    font-weight: 300 !important;
    font-size: 18px !important;
    line-height: 22px !important;
    color: #000000 !important;
}

.feedback-title {
    font-family: Roboto Slab !important;
    font-style: normal !important;
    font-weight: 300 !important;
    font-size: 18px !important;
    line-height: 22px !important;
    color: #000000 !important;
    margin: 0;
}

.feedback-emoji-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
}

.feedback-text-emoji {
    font-family: Roboto Slab !important;
    font-style: normal !important;
    font-weight: 300 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    color: #000000 !important;
    text-align: center;
}

.feedback-emoji {
    font-size: 6rem;
    line-height: 1.2;
    display: inline-block;
}

.feedback-label {
    font-size: 0.85rem;
    margin-top: 0.25rem;
    color: #444;
}

.feedback-list {
    padding-left: 20px;
    list-style: disc;
}

.feedback-list.checked {
    list-style: none;
    padding-left: 0;
}

.feedback-list.checked .feedback-list-item {
    display: flex;
    align-items: center;
    gap: 8px;
}



</style>



// WEBPACK FOOTER //
// src/components/CommunityRequestPageV1Short.vue